/* eslint-disable */
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import React, { useState, useEffect, useRef, useMemo, useCallback, useContext } from 'react';
import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  Slide,
  Checkbox,
  ClickAwayListener,
  TableCell,
  TableHead,
  TableRow,
  Popover,
  Snackbar,
  FormControl,
  Select,
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MaterialTable from 'material-table';
import useStyles from '../../Main.style';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FastField, Formik, Form, Field } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import useForms from '../../../../hooks/useForms';
import usePractice from '../../../../hooks/usePractice';
import useQuickBook from '../../../../hooks/useQuickBook';
import FilterListIcon from '@material-ui/icons/FilterList';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import blankIMage from '../../../../assets/images/TablePlaceholder.png';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CloseIcon from '@material-ui/icons/Close';
import { debounce, set, sortBy } from 'lodash';
import { FOCUS_MODE_EVENTS } from '../../../../constants/actionTypes';
import { FocusModeContext } from '../../../../contexts/focusModeContext';
import SortIcon from '@material-ui/icons/Sort';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Switch from '@material-ui/core/Switch';
import { Alert } from '@material-ui/lab';
const EmployeePerformance = ({ allFinancialCompensationData }) => {
  const classes = useStyles();

  const {
    getCountry,
    fetchAllGlobalGivingCauses,
    fetchAllCellList,
    getCellData,
    getFilteredGlobalCauseDetails,
    deleteGlobalCause,
    getSingleGlobalCause,
    updateGlobalGivingCause,
    getUserDetails,
    getCountriesCells,
    getFilterCountryDetails,
    getDepartmentData,
    saveFilter,
    updateSavedFilter,
    getAllFilters,
    updateFilterName,
    deleteAllFilters,
    deleteSelectedFilter,
  } = usePractice();

  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const navigate = useNavigate();

  const theme = useTheme();
  const [openFilter, setOpenFilter] = React.useState(false);
  const [fpData, setFpData] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [filteredFpData, setFilteredFpData] = useState([]);
  const [filteredFpDataClone, setFilteredFpDataClone] = useState([]);
  const [isApplyClicked, setIsApplyClicked] = useState(false);
  const [filteredColumnList, setFilteredColumnList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [countrySelectedOptions, setCountrySelectedOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [departmentSelectedOptions, setDepartmentSelectedOptions] = useState([]);
  const [cellListForFilter, setCellListForFilter] = useState([]);
  const [copyCellListForFilter, setCopyCellListForFilter] = useState([]);
  const [deptListForFilter, setDeptListForFilter] = useState([]);
  const [yearListForFilter, setYearListForFilter] = useState([]);
  const [selectedSearchId, setSelectedSearchId] = useState(null);
  const [selectedSearchIndex, setSelectedSearchIndex] = useState(null);
  const [selectedRankingField, setSelectedRankingField] = useState(null);
  const SelectAllFields = { label: 'Select All' };
  const [selectedFieldOption, setSelectedFieldOption] = useState([]);

  const SelectAllCountries = { countryTitle: 'Select All' };
  const [selectedCountryOption, setSelectedCountryOption] = useState([]);

  const SelectAllCells = { cellTitle: 'Select All' };
  const [selectedCellOption, setSelectedCellOption] = useState([]);
  const [cellsByCountryIndicator, setCellsByCountryIndicator] = useState({});

  const SelectAllDepartments = { department: 'Select All' };
  const [selectedDepartmentOption, setSelectedDepartmentOption] = useState([]);
  const [selectedValueCell, setSelectedValueCell] = React.useState(null);

  const [defaultYearForFilter, setDefaultYearForFilter] = useState([]);
  const [filterSubmitted, setFilterSubmitted] = useState([]);
  const { getFinParamsUsers } = useForms();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const [searchAnchorEl, setSearchAnchorEl] = React.useState(null);
  const [rankingSubmenuOpen, setRankingSubmenuOpen] = useState(false);
  const popoverRef = useRef(null);
  const [rankDataByWidth, setRankDataByWidth] = React.useState(null);
  const [savedSearches, setSavedSearches] = useState([]);
  const [menuOpen, setMenuOpen] = useState(null);
  const [filterEditMode, setFilterEditMode] = useState(false);
  let reportData = [];
  let finDataAll = [];
  let yearFP = [];
  const [openFilterName, setOpenFilterName] = React.useState(false);
  const [openFilterRename, setOpenFilterRename] = React.useState(false);
  const [openFilterValidation, setOpenFilterValidation] = React.useState(false);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = React.useState(false);
  const [filterSelectedUpdate, setFilterSelectedUpdate] = React.useState({});
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [openCountry, setOpenCountry] = useState(false);
  const [openCountryClick, setOpenCountryClick] = React.useState(false);
  const [selectedSortItem, setSelectedSortItem] = React.useState({});
  const [scrollTop, setScrollTop] = useState(0);

  const [isFinAnalysisVisible, setIsFinAnalysisVisible] = useState(
    (loggedInUserData.department &&
      loggedInUserData.department?.departmentTitle.toLowerCase() == 'administrations') ||
      (loggedInUserData.department &&
        loggedInUserData.department?.departmentTitle.toLowerCase() == 'superadmin') ||
      loggedInUserData.department?.departmentTitle.toLowerCase() == 'corporation' ||
      loggedInUserData.roleId == 1,
  );
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [isFocusMode, dispatchIsFocusMode] = useContext(FocusModeContext);
  const [showSnackBarErr, setShowSnackBarErr] = useState(false);
  const pageFpSizeOptions = [10, 20, 50, 100];

  const [currentFpPage, setCurrentFpPage] = useState(1);
  const [pageFpSize, setFpPageSize] = useState(20);

  const handleRankingMouseEnter = () => {
    setRankingSubmenuOpen(true);
  };

  const handleRankingMouseLeave = () => {
    setRankingSubmenuOpen(false);
  };
  const handleSubmenuEnter = () => {
    setRankingSubmenuOpen(true);
  };

  const handleSubmenuLeave = () => {
    setRankingSubmenuOpen(false);
  };

  const handleFpPageChange = (newFpPage) => {
    setCurrentFpPage(newFpPage);
  };

  const handleFpPageSizeChange = (newFpPageSize) => {
    setFpPageSize(Number(newFpPageSize?.target?.value));
    setCurrentFpPage(1);
  };

  const formatToCustomerCurrency_BAK = (data, styles, type) => {
    if (data === null) {
      return 'N/A';
    }
    if (!data || data?.length === 0) {
      return 'N/A';
    }
    const cleanedData = /[$,]/.test(data) ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);
    if (numberData < 0) {
      // Format the number as a currency and apply custom formatting for negative values
      const formattedValue = `(-$${Math.abs(numberData).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })})`;
      return <Typography className={styles.TableTextRed}>{formattedValue + ' ' + type}</Typography>;
    }
    // Format positive numbers normally
    return `$${numberData.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} ${type}`;
  };

  const formatToCustomerCurrency = (data, styles, type) => {
    if (data === 0) {
      return 0.0;
    }

    if (data === null) {
      return 'N/A';
    }
    if (!data || data?.length === 0) {
      return 0.0;
    }
    const cleanedData = /[$,]/.test(data) ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);
    // Format positive numbers normally
    return numberData.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const startFpIndex = (currentFpPage - 1) * pageFpSize;
  const endFpIndex = startFpIndex + pageFpSize;
  let displayedFpData = selectedSortItem.sortField
    ? filteredFpData.slice(startFpIndex, endFpIndex)
    : filteredFpDataClone.slice(startFpIndex, endFpIndex) || [];
  // New Code
  const handleSnackBarClose = () => {
    setShowSnackBarErr(false);
  };

  const redirectPage = (rowData) => {
    window.open('#/app/view-employee/' + rowData?.employeeId + '/' + rowData?.countryId, '_blank');
  };

  const handleFocusModeClick = () => {
    if (!isFocusMode.isFocusMode) {
      enterFullscreen();
    } else {
      exitFullscreen();
    }
    dispatchIsFocusMode({ type: FOCUS_MODE_EVENTS.SUCCESS, payload: !isFocusMode.isFocusMode });
  };

  const handleEditMode = () => {
    setFilterEditMode((prev) => !prev);
  };

  const enterFullscreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };

  const handleFullscreenChange = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    ) {
      // User is in fullscreen mode
      dispatchIsFocusMode({ type: FOCUS_MODE_EVENTS.SUCCESS, payload: true });
    } else {
      // User has exited fullscreen mode
      dispatchIsFocusMode({ type: FOCUS_MODE_EVENTS.SUCCESS, payload: false });
    }
  };
  const handleToggleColumn = (field) => {
    if (field) {
      setHiddenColumns((prevHiddenColumns) => {
        // hide column functionality
        const updatedHiddenColumns = prevHiddenColumns.includes(field)
          ? prevHiddenColumns.filter((column) => column !== field)
          : [...prevHiddenColumns, field];

        for (let i = 0; i < filteredColumnList.length; i++) {
          filteredColumnList[i].hidden = updatedHiddenColumns.includes(filteredColumnList[i].field);
        }
        return updatedHiddenColumns;
      });
    } else {
      setHiddenColumns([]);

      for (let i = 0; i < filteredColumnList.length; i++) {
        filteredColumnList[i].hidden = false;
      }
    }
  };

  const clearAll = () => {
    filterFpData({
      country: null,
      cell: null,
    });
    setSelectedCountryOption([]);
    setSelectedCellOption([]);
    setSelectedDepartmentOption([]);
    setSelectedFieldOption([]);
    setOpenFilter(false);
    setIsApplyClicked(false);
    setSelectedSortItem({});
    setLoaded(false);
  };

  const containerStyle = {
    maxWidth: '100%',
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  };

  const imageStyle = {
    maxWidth: '310px',
    maxHeight: '100%',
  };
  const periodOptions = [
    { label: 'Full Year', value: 'fullYear' },
    { label: 'January - June', value: 'janJune', disabled: true },
    { label: 'July - December', value: 'julyDec', disabled: true },
    { label: 'Q1', value: 'q1', disabled: true },
    { label: 'Q2', value: 'q2', disabled: true },
    { label: 'Q3', value: 'q3', disabled: true },
    { label: 'Q4', value: 'q4', disabled: true },
  ];

  const [filterName, setFilterName] = useState('');
  const [filterRename, setFilterRename] = useState('');
  const [isFilterNameValid, setFilterNameValid] = useState(true);
  const [isFilterRenameValid, setFilterRenameValid] = useState(true);

  const fieldOptions = [
    { label: 'Salary', value: 'salary' },
    { label: 'Bonuses', value: 'bonuses' },
    { label: 'Commissions', value: 'commissions' },
    { label: 'Benefits', value: 'benefits' },
    { label: 'Ranking', value: 'ranking' },
  ];

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [formQuestions, setFormQuestions] = useState([]);

  const [anchorMts, setAnchorMts] = React.useState([]);
  const [anchorPositions, setAnchorPositions] = React.useState([]);

  const handleMtMenuClick = (event, columnIndex) => {
    const updatedAnchorMts = [...anchorMts];
    updatedAnchorMts[columnIndex] = event.currentTarget;
    setAnchorMts(updatedAnchorMts);

    const updatedAnchorPositions = [...anchorPositions];
    updatedAnchorPositions[columnIndex] = { top: event.pageY - scrollTop, left: event.pageX };

    setAnchorPositions(updatedAnchorPositions);
  };

  const handleToggleOpen = (source) => {
    if (source == 'open') {
      setOpenCountry(true);
    } else if (source == 'close') {
      setOpenCountry(false);
    } else if ('changeEvent') {
      setOpenCountry(true);
    }
  };

  const handleMtMenuClose = (columnIndex) => {
    const updatedAnchorMts = [...anchorMts];
    updatedAnchorMts[columnIndex] = null;
    setAnchorMts(updatedAnchorMts);

    const updatedAnchorPositions = [...anchorPositions];
    updatedAnchorPositions[columnIndex] = null;
    setAnchorPositions(updatedAnchorPositions);
  };

  const calculateRank = (item, field) => {
    let rankingFilteredFpData = [...filteredFpData];
    let obj = fieldOptions.find((o) => o.value === field);
    // Ranking popover
    obj?.label.toLowerCase() != 'ranking' && setSelectedRankingField(obj?.label);
    rankingFilteredFpData = sortFloatValues(rankingFilteredFpData, field, 'sort down');

    rankingFilteredFpData.forEach((obj, index) => {
      obj.ranking.rankValue = index + 1;
    });

    setFilteredFpData(rankingFilteredFpData);
  };

  const handleMenuItemClick = debounce((item, field, columnIndex) => {
    if (columnIndex === 0) {
      calculateRank(item, field);
    }

    if (item.toLowerCase() === 'show ranking') {
      calculateRank(item, field);
    }

    if (item.toLowerCase() === 'hide column') {
      handleToggleColumn(field);
    }

    if (item.toLowerCase() == 'sort up' || item.toLowerCase() == 'sort down') {
      if (
        selectedSortItem?.sortType &&
        columnIndex === selectedSortItem?.sortColumnIndex &&
        item.toLowerCase() === selectedSortItem?.sortType
      ) {
        setSelectedSortItem({});
      } else {
        setSelectedSortItem({
          sortType: item.toLowerCase(),
          sortField: field,
          sortColumnIndex: columnIndex,
        });

        let sortItems = [...filteredFpData];
        if (item.toLowerCase() == 'sort up') {
          if (
            field === 'salary' ||
            field === 'bonuses' ||
            field === 'commissions' ||
            field === 'benefits' ||
            field === 'ranking' // Ranking popover
          ) {
            if (field === 'ranking') {
              sortItems.sort(function (a, b) {
                return Number(a?.ranking?.rankValue) - Number(b?.ranking?.rankValue);
              });
            } else {
              sortItems = sortFloatValues(sortItems, field, 'sort up');
            }
          } else {
            sortItems.sort((a, b) => {
              return compareNames(a[field], b[field]);
            });
          }

          setFilteredFpData(sortItems);
        } else if (item.toLowerCase() == 'sort down') {
          if (
            field === 'salary' ||
            field === 'bonuses' ||
            field === 'commissions' ||
            field === 'benefits' ||
            field === 'ranking' // Ranking popover
          ) {
            if (field === 'ranking') {
              sortItems.sort(function (a, b) {
                return Number(b?.ranking?.rankValue) - Number(a?.ranking?.rankValue);
              });
            } else {
              sortItems = sortFloatValues(sortItems, field, 'sort down');
            }
          } else {
            sortItems.sort((a, b) => {
              return compareNames(b[field], a[field]);
            });
          }

          setFilteredFpData(sortItems);
        }
      }
    }

    if (item.toLowerCase() === 'unhide columns') {
      handleToggleColumn();
    }
    handleMtMenuClose(columnIndex);
  }, 100);

  const compareNames = (nameA, nameB) => {
    if (nameA === undefined && nameB === undefined) {
      return 0;
    }
    if (nameA === undefined) {
      return -1;
    }
    if (nameB === undefined) {
      return 1;
    }
    return nameA.localeCompare(nameB);
  };

  function formatNumberWithPrecision(value, precision) {
    return parseFloat(value).toFixed(precision);
  }

  const sortFloatValues = (sortItems, field, sortType) => {
    if (!selectedRankingField) {
      let obj = fieldOptions.find((o) => o.value === field);
      setSelectedRankingField(obj?.label);
    }
    sortItems.sort((a, b) => {
      const strA = a[field];
      const strB = b[field];

      // Check if either strA or strB is NaN (not a number)
      const isStrANaN = isNaN(parseFloat(strA));
      const isStrBNaN = isNaN(parseFloat(strB));

      // Handle NaN cases first
      if (isStrANaN && isStrBNaN) {
        return 0; // Both values are NaN, so they are considered equal
      } else if (isStrANaN) {
        // strA is NaN, move it to the end regardless of sort type
        return 1;
      } else if (isStrBNaN) {
        // strB is NaN, move it to the end regardless of sort type
        return -1;
      }

      // At this point, both strA and strB are numeric values represented as strings

      const numA = parseFloat(String(strA)?.replace(/[^\d.-]/g, ''));
      const numB = parseFloat(String(strB)?.replace(/[^\d.-]/g, ''));

      const precision = 3; // Set the desired precision here

      if (sortType === 'sort up') {
        return (
          parseFloat(formatNumberWithPrecision(numA, precision)) -
          parseFloat(formatNumberWithPrecision(numB, precision))
        );
      } else if (sortType === 'sort down') {
        return (
          parseFloat(formatNumberWithPrecision(numB, precision)) -
          parseFloat(formatNumberWithPrecision(numA, precision))
        );
      }

      // If the sortType is not 'sort up' or 'sort down', return 0 to indicate no change
      return 0;
    });

    return sortItems;
  };

  const headerComponent = (column, columnIndex) => {
    return (
      <>
        <If condition={columnIndex === 0 && column.field == 'ranking'}>
          {' '}
          {rankingSubmenuOpen && (
            <>
              <div
                style={{
                  position: 'absolute',
                  top: rankDataByWidth.top,
                  left: rankDataByWidth.left + rankDataByWidth.width,
                  backgroundColor: 'white',
                  borderRadius: '4px',
                  boxShadow:
                    '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
                  zIndex: '1301',
                  display: rankingSubmenuOpen ? 'block' : 'none',
                }}
              >
                {fieldOptions.map((field) => {
                  if (field.value !== 'selectAll' && field.value !== 'ranking') {
                    const searchValue = field?.value;
                    const exists = filteredColumnList.some((obj) => obj.field === searchValue);

                    return (
                      <>
                        <MenuItem
                          disabled={!exists}
                          onMouseEnter={handleRankingMouseEnter}
                          onMouseLeave={handleRankingMouseLeave}
                          onClick={() => handleMenuItemClick(field.value, field.value, 0)}
                        >
                          {field.label}
                        </MenuItem>
                      </>
                    );
                  }
                })}
              </div>
            </>
          )}
        </If>

        <Box className={classes.RankingDetailTop}>
          {(columnIndex === 0 &&
            selectedRankingField &&
            selectedRankingField[0].toUpperCase() + selectedRankingField.slice(1).toLowerCase()) ||
            ''}
        </Box>
        <Box display="flex" alignItems="center">
          {column?.title}

          <Button
            aria-controls={`menu-options-${column?.field}`}
            aria-haspopup="true"
            onClick={(event) => handleMtMenuClick(event, columnIndex)}
          >
            <ExpandMoreIcon />
          </Button>
          {selectedSortItem?.sortColumnIndex === columnIndex &&
          selectedSortItem?.sortType == 'sort up' ? (
            <>
              <Box display="flex" className={classes.TableSortIcon}>
                <SortIcon />
              </Box>
            </>
          ) : selectedSortItem?.sortColumnIndex === columnIndex &&
            selectedSortItem?.sortType == 'sort down' ? (
            <>
              <Box display="flex" className={classes.TableSortIconClicked}>
                <SortIcon />
              </Box>
            </>
          ) : (
            ''
          )}
        </Box>

        <Popover
          className={classes.MoreOptionsV2}
          id={`menu-options-${column?.field}`}
          anchorEl={anchorMts[columnIndex]}
          keepMounted
          open={Boolean(anchorMts[columnIndex])}
          onClose={() => handleMtMenuClose(columnIndex)}
          anchorReference="anchorPosition"
          anchorPosition={anchorPositions[columnIndex]}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <If condition={column?.field !== 'ranking'}>
            <If condition={fieldOptions.some((field) => field?.value === column?.field)}>
              <MenuItem
                onClick={() => handleMenuItemClick('show Ranking', column?.field, columnIndex)}
              >
                Show Ranking
              </MenuItem>
            </If>
            <MenuItem
              className={
                selectedSortItem.sortType == 'sort up' &&
                selectedSortItem.sortColumnIndex === columnIndex
                  ? 'Mui-selected'
                  : ''
              }
              onClick={() => handleMenuItemClick('Sort Up', column.field, columnIndex)}
            >
              Sort Up
            </MenuItem>
            <MenuItem
              className={
                selectedSortItem.sortType == 'sort down' &&
                selectedSortItem.sortColumnIndex === columnIndex
                  ? 'Mui-selected'
                  : ''
              }
              onClick={() => handleMenuItemClick('Sort Down', column.field, columnIndex)}
            >
              Sort Down
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick('Hide Column', column.field, columnIndex)}>
              Hide Column
            </MenuItem>
            <MenuItem
              disabled={hiddenColumns.length == 0}
              onClick={() => handleMenuItemClick('Unhide Columns', column.field, columnIndex)}
            >
              Unhide Columns
            </MenuItem>
          </If>
          <If condition={column.field == 'ranking'}>
            <MenuItem
              style={{
                display: 'inline-block',
                padding: '8px 12px',
                cursor: 'pointer',
                width: '100%',
              }}
              onMouseEnter={handleRankingMouseEnter}
              onMouseLeave={handleRankingMouseLeave}
              ref={popoverRef}
            >
              Rank Data By
            </MenuItem>
            <MenuItem
              className={
                selectedSortItem.sortType == 'sort up' &&
                selectedSortItem.sortColumnIndex === columnIndex
                  ? 'Mui-selected'
                  : ''
              }
              onClick={() => handleMenuItemClick('Sort Up', column.field, columnIndex)}
            >
              Sort Up
            </MenuItem>
            <MenuItem
              className={
                selectedSortItem.sortType == 'sort down' &&
                selectedSortItem.sortColumnIndex === columnIndex
                  ? 'Mui-selected'
                  : ''
              }
              onClick={() => handleMenuItemClick('Sort Down', column.field, columnIndex)}
            >
              Sort Down
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick('Hide Column', column.field, columnIndex)}>
              Hide Column
            </MenuItem>
            <MenuItem
              disabled={hiddenColumns.length == 0}
              onClick={() => handleMenuItemClick('Unhide Columns', column.field, columnIndex)}
            >
              Unhide Columns
            </MenuItem>
          </If>
        </Popover>
      </>
    );
  };

  let columns = [
    {
      title: 'Ranking',
      field: 'ranking',
      render: (data) => {
        return <Box className={classes.RankingNumber}>{data?.ranking?.rankValue}</Box>;
      },
      hidden: hiddenColumns.includes('ranking'), // ranking popover
    },
    {
      title: 'Employee Name',
      field: 'employee',
      render: (data) => data?.employee,
      hidden: hiddenColumns.includes('employee'),
    },
    {
      title: 'Country',
      field: 'country',
      render: (data) => data?.country,
      hidden: hiddenColumns.includes('country'),
    },
    {
      title: 'Cell',
      field: 'cell',
      render: (data) => data?.cell,
      hidden: hiddenColumns.includes('cell'),
    },
    {
      title: 'Department',
      field: 'department',
      render: (data) => data?.department,
      hidden: hiddenColumns.includes('department'),
    },
    {
      title: 'Salary',
      field: 'salary',
      render: (data) => data?.salary,
      hidden: hiddenColumns.includes('salary'),
    },
    {
      title: 'Bonuses',
      field: 'bonuses',
      render: (data) => data?.bonuses,
      hidden: hiddenColumns.includes('bonuses'),
    },
    {
      title: 'Commissions',
      field: 'commissions',
      render: (data) => data?.commissions,
      hidden: hiddenColumns.includes('commissions'),
    },
    {
      title: 'Benefits',
      field: 'benefits',
      render: (data) => data?.benefits,
      hidden: hiddenColumns.includes('benefits'),
    },
    // {
    //   title: 'Total',
    //   field: 'total',
    //   render: (data) => data?.total,
    //   hidden: hiddenColumns.includes('total'),
    // },
  ];

  // const handleClickOpenFilterName = () => {
  //   setOpenFilterName(true);
  // };

  const renderHeader = () => {
    return (
      <tr>
        {filteredColumnList.map((column, columnIndex) => {
          // if (column.field !== 'ranking' && !column.hidden) {
          if (!column.hidden) {
            return <td key={column.field}>{headerComponent(column, columnIndex)}</td>;
          }
          // else if (column.field == 'ranking') {
          //   return <td key={column.field}>{headerComponent(column, columnIndex)}</td>;
          // }
        })}
      </tr>
    );
  };

  const handleCloseFilterName = () => {
    setOpenFilterName(false);
    handleCloseFilterValidation();
    setFilterName('');
  };

  const handleCloseFilterValidation = async () => {
    setOpenFilterValidation(false);
  };

  const addSelClassToSearchButton = (index) => {
    const buttons = document.querySelectorAll(`[id^="button-"]`);
    const clickedButton = document.getElementById('button-' + index);
    const parentDiv = clickedButton.parentElement;
    buttons.forEach((button) => {
      if (button !== clickedButton) {
        const parentDiv = button.parentElement;
        parentDiv.classList.add(classes.TableInnerFilter);
        parentDiv.classList.remove(classes.TableInnerFilterSelect);
      }
    });

    parentDiv.classList.add(classes.TableInnerFilterSelect); // Add filterselected class to the clicked button
    parentDiv.classList.remove(classes.TableInnerFilter);
  };

  const handleSearchButtonClick = async (
    event,
    index,
    _id,
    _values,
    selectedSection,
    { resetForm },
  ) => {
    setHiddenColumns([]);
    const clickedButton = event.target.parentElement;
    const parentDiv = clickedButton.parentElement;
    const buttonId = `button-${index}`;
    const buttonArrowId = `buttonArrow-${index}`;
    const buttonElement = event.currentTarget;
    const buttonIdFromEvent = buttonElement.getAttribute('id');

    if (selectedSection == 'button') {
      setSelectedSearchIndex(index);
      setSelectedSearchId(_id);
      if (selectedSearchIndex == index) {
        clearSelectedSearch({ resetForm });
      } else {
        if (
          clickedButton.parentElement.tagName !== 'SPAN' &&
          !clickedButton.parentElement.id.includes('buttonArrow')
        ) {
          addSelClassToSearchButton(index);
          setFilterSelectedUpdate({});
          setFilterSelectedUpdate(savedSearches.filter((elem) => elem.id === _id));

          if (buttonId === buttonIdFromEvent) {
            await loadSelectedSearch(_id, _values);
          }
        }
      }
    } else if (selectedSection == 'arrow') {
      if (buttonArrowId === buttonIdFromEvent) {
        if (selectedSearchIndex == buttonArrowId.split('-')[1]) {
          setSearchAnchorEl(buttonElement);
        }
      }
    }
  };

  const loadSelectedSearch = async (_id, _values) => {
    const selectedSearch = savedSearches.filter((elem) => elem.id === _id);
    //new code
    clearAll();
    //new code
    _values['countryid'] = selectedSearch[0].country.length > 0 ? selectedSearch[0].country : [];
    _values['cellid'] = selectedSearch[0].cell.length > 0 ? selectedSearch[0].cell : [];
    _values['yearid'] = Number(selectedSearch[0].year);
    _values['period'] = selectedSearch[0].period;
    _values['deptid'] = selectedSearch[0].department.length > 0 ? selectedSearch[0].department : [];
    _values['fieldoptionid'] = selectedSearch[0].metrics || [];
    setSelectedYear(selectedSearch[0].year);
    if (selectedSearch[0].country.length > 0) {
      let loadedCountries = [];
      selectedSearch[0].country.map((country) => {
        loadedCountries.push(JSON.parse(country));
      });

      await loadCellsForFilter(loadedCountries);
    }

    const loadedFpData = await loadFpData();

    setLoadedFilterOptions('cell', _values);
    let isNewEntry = false;
    if (allFinancialCompensationData.length > 0) {
      isNewEntry = await updateArrayB(
        allFinancialCompensationData,
        reportData,
        yearListForFilter.find((d) => d?.id == selectedSearch[0].year)?.year,
      );
    }
    await fillReportState(
      loadedFpData,
      yearListForFilter.find((d) => d?.id == selectedSearch[0].year)?.year,
    );

    setFilterSubmitted(_values);
    setTimeout(async () => {
      const flagFilter = await filterFpData(_values);
      return flagFilter;
    }, 1000);
  };

  const setLoadedFilterOptions = (field, _values) => {
    setSelectedFieldOption([]);
    setSelectedCountryOption([]);
    setSelectedCellOption([]);
    setSelectedDepartmentOption([]);

    const fieldToLoad = fieldOptions
      .map((field) => {
        if (_values['fieldoptionid'].some((f) => f === field.value)) {
          return field;
        }
      })
      .filter((field) => field !== undefined);

    setSelectedFieldOption(fieldToLoad);

    const countryToLoad = _values['countryid'].map((country) => {
      return JSON.parse(country);
    });
    setSelectedCountryOption(countryToLoad);

    const cellsToLoad = _values['cellid'].map((cell) => {
      return JSON.parse(cell);
    });
    setSelectedCellOption(cellsToLoad);

    const deptsToLoad = _values['deptid'].map((department) => {
      return JSON.parse(department);
    });
    setSelectedDepartmentOption(deptsToLoad);
  };

  const handleMenuClose = () => {
    setSearchAnchorEl(null); // Close the menu
  };

  const handleOutsideClick = () => {};
  const handleDeleteSearch = async (searchId, { resetForm }) => {
    const result = await deleteSelectedFilter({ userId: loggedInUserData?.id, searchId: searchId });

    if (result) {
      clearAll();
      loadAllFilters();
      handleMenuClose();
      clearSelectedSearch({ resetForm });
    }
  };

  const openDeleteConfirmationBox = async () => {
    handleSubmenuClose();
    setOpenDeleteConfirmation(true);
    handleClose();
  };

  const handleDeleteSavedSearches = async ({ resetForm }, isDeleteAll) => {
    handleSubmenuClose();
    closeDeleteConfirmation();
    //Actual Delete code
    if (isDeleteAll) {
      const result = await deleteAllFilters({ userId: loggedInUserData?.id });
      if (result) {
        loadAllFilters();
        clearSelectedSearch({ resetForm });
      }
    } else {
      handleDeleteSearch(selectedSearchId, { resetForm });
    }
  };

  const closeDeleteConfirmation = async () => {
    setOpenDeleteConfirmation(false);
  };
  const handleRenameButton = (_id) => {
    handleMenuClose();
    setOpenFilterRename(true);
    setFilterSelectedUpdate({});
    if (savedSearches && savedSearches.length > 0) {
      setFilterRename(savedSearches.filter((elem) => elem.id === _id)[0]?.filterName);
      setFilterSelectedUpdate(savedSearches.filter((elem) => elem.id === _id));
    }
  };
  const handleCloseFilterRename = () => {
    setOpenFilterRename(false);
    setFilterSelectedUpdate({});
  };
  const loadFpData = async () => {
    finDataAll = await getFinParamsUsers();
    //fillReportState(finDataAll);
    return finDataAll;
  };

  const loadCountries = async () => {
    const countryLists = await getCountry();
    if (countryLists.usersResult) {
      // countryLists.usersResult.unshift({ id: '1', countryTitle: 'Select All' });
      setCountryList(countryLists.usersResult);
    }
  };

  const loadAllCellList = async () => {
    const cellLists = await fetchAllCellList();
    setCopyCellListForFilter(cellLists.usersResult);
    setCellListForFilter(cellLists.usersResult);
  };

  const loadCellsForFilter = async (countryIdList) => {
    if (countryIdList.length > 0) {
      const CellList = await getCountriesCells(countryIdList);
      // CellList.usersResult.unshift({ id: '1', cellTitle: 'Select All' });
      setCellListForFilter(CellList.usersResult);
    } else {
      setCellListForFilter(copyCellListForFilter);
    }
  };

  const loadDeptForFilter = async () => {
    const DeptList = await getDepartmentData();
    if (DeptList.usersResult) {
      // DeptList.usersResult.unshift({ id: '1', department: 'Select All' });
      setDeptListForFilter(DeptList.usersResult);
    }
  };

  const loadYearForFilter = async () => {
    const currentYear = new Date().getFullYear();
    const startYear = 2019;
    const numberOfYears = currentYear - startYear + 1;

    const yearsArray = Array.from({ length: numberOfYears }, (_, index) => {
      return {
        id: (index % 6) + 1,
        year: (startYear + index).toString(),
      };
    });

    setYearListForFilter(yearsArray);
    return yearsArray;
  };

  const fillReportState = async (formResponse, selectedYearParam) => {
    if (formResponse?.usersResult !== undefined && formResponse?.usersResult !== null) {
      const reponseByYear = Object.values(
        formResponse?.usersResult.reduce((acc, obj) => {
          const key = obj.formTrackerId;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(obj);
          return acc;
        }, {}),
      );

      let formValues = {};

      reponseByYear.map((year) => {
        year.map((ans) => {
          let questionText = ans?.text;
          if (
            questionText ===
            "Bonuses – After break up with Kronoz (Dec - 2012) : Sales' Commissions"
          ) {
            formValues['bonuses'] =
              ans?.answer != '0' || ans?.answer != 0
                ? formatToCustomerCurrency(
                    ans?.answer == null ? null : Number(ans?.answer),
                    classes,
                    '',
                  )
                : 0.0;
            formValues['bonusesValue'] = ans?.answer ? parseFloat(ans?.answer) : '';
          } else if (questionText === "Other: Loan/Sales' Commissions") {
            // formValues['commissions'] =
            //   ans?.answer != '0' || ans?.answer != 0
            //     ? parseFloat(ans?.answer).toLocaleString(undefined, { maximumFractionDigits: 3 })
            //     : 'N/A';

            formValues['commissions'] =
              ans?.answer != '0' || ans?.answer != 0
                ? formatToCustomerCurrency(
                    ans?.answer == null ? null : Number(ans?.answer),
                    classes,
                    '',
                  )
                : 0.0;
            formValues['commissionsValue'] = ans?.answer ? parseFloat(ans?.answer) : '';
          } else if (questionText === 'Salary – total $ paid each year before taxes') {
            formValues['salary'] =
              ans?.answer != '0' || ans?.answer != 0
                ? formatToCustomerCurrency(
                    ans?.answer == null ? null : Number(ans?.answer),
                    classes,
                    '',
                  )
                : 0.0;
            formValues['salaryValue'] = ans?.answer ? parseFloat(ans?.answer) : '';
          } else if (questionText === 'Benefits – total $ paid by VGL for healthcare') {
            formValues['benefits'] =
              ans?.answer != '0' || ans?.answer != 0
                ? formatToCustomerCurrency(
                    ans?.answer == null ? null : Number(ans?.answer),
                    classes,
                    '',
                  )
                : 0.0;
            formValues['benefitsValue'] = ans?.answer ? parseFloat(ans?.answer) : '';
          } else {
            formValues[questionText] = ans?.answer ? ans?.answer : '';
          }

          let bonusesValue = selectedFieldOption.some((field) => field?.value === 'bonuses')
            ? Number(formValues['bonusesValue'])
            : 0;

          let commissionsValue = selectedFieldOption.some((field) => field?.value === 'commissions')
            ? Number(formValues['commissionsValue'])
            : 0;
          let salaryValue = selectedFieldOption.some((field) => field?.value === 'salary')
            ? Number(formValues['salaryValue'])
            : 0;

          let benefitsValue = selectedFieldOption.some((field) => field?.value === 'benefits')
            ? Number(formValues['benefitsValue'])
            : 0;

          let totalAmount = bonusesValue + commissionsValue + salaryValue + benefitsValue;
          formValues['total'] = parseFloat(totalAmount).toLocaleString(undefined, {
            maximumFractionDigits: 3,
          });

          formValues['employee'] = ans?.firstName + ' ' + ans?.lastName;
          formValues['employeeId'] = ans?.userDetails?.id;
          formValues['countryId'] = ans?.userDetails?.country?.id;
          formValues['country'] = ans?.userDetails?.country?.countryTitle;
          formValues['cell'] = ans?.userDetails?.cell?.cellTitle;
          formValues['department'] = ans?.userDetails?.department?.departmentTitle;
        });

        formValues['year'] = year[0]?.year;
        reportData.push(formValues);
        formValues = {};
      });

      // formValues['benefits'] = '500';
      // formValues['benefitsValue'] = '500';
      // formValues['bonuses'] = '500';
      // formValues['bonusesValue'] = '500';
      // formValues['cell'] = '';
      // formValues['commissions'] = '500';
      // formValues['commissionsValue'] = '500';
      // formValues['country'] = '';
      // formValues['countryId'] = '';
      // formValues['department'] = '';
      // formValues['employee'] = 'Total';
      // formValues['employeeId'] = '9a97c0c1-078c-4b10-9c1d-f1fe4996d1de';
      // formValues['salary'] = '500';
      // formValues['salaryValue'] = '500';
      // formValues['total'] = '500';
      // formValues['year'] = '2024';
      // reportData.push(formValues);
      // formValues = {};
      setFpData(reportData);
      setFilteredFpData(reportData);
    }
  };

  const filterFields = (_fpDAta, _fieldArray) => {
    const fieldArrayElements = new Set(_fieldArray);

    // Iterate over array1 and remove unwanted properties
    const result = _fpDAta.map((obj) => {
      const newObj = {};

      for (const prop in obj) {
        if (
          fieldArrayElements.has(prop) ||
          prop === 'employee' ||
          prop === 'country' ||
          prop === 'cell' ||
          prop === 'department' ||
          prop === 'total' ||
          prop === 'countryId' ||
          prop == 'employeeId'
        ) {
          newObj[prop] = obj[prop];
        }
      }

      return newObj;
    });

    return result;
  };

  const isValidJSON = (obj) => {
    try {
      JSON.parse(obj);
      return true;
    } catch (error) {
      return false;
    }
  };

  function mergeObjects(obj1, obj2) {
    const mergedObj = {};

    const mergeValues = (value1, value2) => {
      if (Array.isArray(value1) && Array.isArray(value2)) {
        if (value1.length >= value2.length) {
          return value1;
        } else {
          return value2;
        }
      } else if (Array.isArray(value2)) {
        return value2;
      }
      return value1 !== undefined ? value1 : [];
    };

    for (let prop in obj1) {
      if (obj1.hasOwnProperty(prop)) {
        mergedObj[prop] = mergeValues(obj1[prop], obj2[prop]);
      }
    }

    for (let prop in obj2) {
      if (obj2.hasOwnProperty(prop)) {
        if (!(prop in mergedObj)) {
          mergedObj[prop] = mergeValues(obj1[prop], obj2[prop]);
        }
      }
    }

    return mergedObj;
  }

  function mergeArrToObject(obj1, obj2) {
    const mergedObj = {};

    for (let prop in obj1) {
      if (obj1.hasOwnProperty(prop)) {
        if (Array.isArray(obj1[prop]) && Array.isArray(obj2[prop])) {
          const mergedArray = [...obj1[prop], ...obj2[prop]];
          mergedObj[prop] = mergedArray;
        } else {
          mergedObj[prop] = obj1[prop];
        }
      }
    }

    for (let prop in obj2) {
      if (obj2.hasOwnProperty(prop)) {
        if (!(prop in mergedObj)) {
          mergedObj[prop] = obj2[prop];
        } else if (Array.isArray(obj2[prop]) && !Array.isArray(mergedObj[prop])) {
          mergedObj[prop] = obj2[prop];
        } else if (typeof obj2[prop] === 'object') {
          mergedObj[prop] = mergeObjects(mergedObj[prop], obj2[prop]);
        }
      }
    }

    return mergedObj;
  }

  useEffect(() => {}, [fpData, filteredColumnList, selectedYear]);

  const filterFpData = async (filter) => {
    setOpenFilter(false);

    let filteredFpData = [];

    if (filter?.countryid) {
      const searchDataset =
        filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;
      const parsedCountryIds = filter.countryid.reduce((acc, c) => {
        if (isValidJSON(c)) {
          acc.push(JSON.parse(c));
        } else {
          acc.push(c);
        }
        return acc;
      }, []);

      filteredFpData = searchDataset.filter((elem) =>
        parsedCountryIds.find((parsedId) => parsedId.countryTitle === elem.country),
      );
    }
    if (filter?.cellid) {
      const searchDataset =
        filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;

      const parsedCellIds = filter.cellid.reduce((acc, c) => {
        if (isValidJSON(c)) {
          acc.push(JSON.parse(c));
        } else {
          acc.push(c);
        }
        return acc;
      }, []);
      if (parsedCellIds.length > 0) {
        filteredFpData = searchDataset.filter((elem) =>
          parsedCellIds.find((parsedId) => parsedId.cellTitle === elem.cell),
        );
      }
    }
    if (filter?.deptid) {
      const searchDataset =
        filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;
      //let searchDataset = filteredFpData;

      if (filter?.deptid.length > 0 && filter?.cellid.length > 0 && filter?.countryid.length > 0) {
        filteredFpData = searchDataset.filter((elem) =>
          filter?.deptid.find((c) => {
            if (isValidJSON(c)) {
              return JSON.parse(c).department === elem?.department;
            } else {
              return c?.department === elem?.department;
            }
          }),
        );
      } else if (
        filter?.deptid.length > 0 &&
        filter?.fieldoptionid &&
        filter?.fieldoptionid.length > 0 &&
        filter?.countryid == 0 &&
        filter?.cellid == 0
      ) {
        searchDataset =
          filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;
        filteredFpData = searchDataset.filter((elem) =>
          filter?.deptid.find((c) => {
            if (isValidJSON(c)) {
              return JSON.parse(c).department === elem.department;
            } else {
              return c.department === elem.department;
            }
          }),
        );
      }

      // if (filteredFpData.length == 0) {
      //   filteredFpData = searchDataset;
      // }
    }
    if (filter?.yearid) {
      //year Filter added
      const yearObj = yearListForFilter.length
        ? yearListForFilter.find((obj) => obj.id === filter?.yearid)
        : await loadYearForFilter().find((obj) => obj.id === filter?.yearid);

      // const searchDataset =
      //   filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;
      const searchDataset = filteredFpData.length > 0 ? filteredFpData : [];
      filteredFpData = searchDataset.filter((l) => {
        return l?.year === yearObj.year;
      });
    }

    if (!filter?.yearid) {
      //year Filter added
      const yearObj = yearListForFilter.length
        ? yearListForFilter.find(
            (obj) => obj.id === yearListForFilter[yearListForFilter.length - 1]?.id,
          )
        : await loadYearForFilter().find(
            (obj) => obj.id === yearListForFilter[yearListForFilter.length - 1]?.id,
          );

      // const searchDataset =
      //   filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;
      const searchDataset = filteredFpData.length > 0 ? filteredFpData : [];
      filteredFpData = searchDataset.filter((l) => {
        return l?.year === yearObj.year;
      });
    }

    if (filter?.fieldoptionid) {
      filteredFpData = filterFields(
        filteredFpData.length > 0 ? filteredFpData : [],
        filter?.fieldoptionid,
      );

      // Default Sorting option when search result is loaded - Begin
      filteredFpData = sortFloatValues(
        filteredFpData,
        fieldOptions[1].value ||
          fieldOptions[2].value ||
          fieldOptions[3].value ||
          fieldOptions[4].value,
        'sort down',
      );
      filteredFpData.map((fpRecord, rankIndex) => {
        fpRecord['ranking'] = { fieldSelected: '', rankValue: rankIndex + 1 };
      });
      filteredFpData.sort((a, b) => {
        return compareNames(a['employee'], b['employee']);
      });
      // Default Sorting option when search result is loaded - End

      // Get all existing properties in filteredFieldData
      const existingProperties = filteredFpData
        ? filteredFpData.reduce((properties, data) => {
            Object.keys(data).forEach((property) => {
              if (!properties.includes(property)) {
                properties.push(property);
              }
            });
            return properties;
          }, [])
        : [];

      const filteredColumns = columns.filter((column) => {
        return existingProperties.includes(column.field);
      });
      setFilteredColumnList(filteredColumns);
    }
    // let formValues = {};
    // formValues['benefits'] = '500';
    //   formValues['benefitsValue'] = '500';
    //   formValues['bonuses'] = '500';
    //   formValues['bonusesValue'] = '500';
    //   formValues['cell'] = '';
    //   formValues['commissions'] = '500';
    //   formValues['commissionsValue'] = '500';
    //   formValues['country'] = '';
    //   formValues['countryId'] = '';
    //   formValues['department'] = '';
    //   formValues['employee'] = 'Total';
    //   formValues['employeeId'] = '9a97c0c1-078c-4b10-9c1d-f1fe4996d1de';
    //   formValues['salary'] = '500';
    //   formValues['salaryValue'] = '500';
    //   formValues['total'] = '500';
    //   formValues['year'] = '2024';
    //   filteredFpData.push(formValues);
    setFilteredFpData(filteredFpData);
    setFilteredFpDataClone(filteredFpData);
    return true;
  };

  const loadAllFilters = async () => {
    if (loggedInUserData) {
      const filterData = await getAllFilters({ userId: loggedInUserData?.id });
      setSavedSearches(filterData.usersResult);
    }
  };

  const clearSelectedSearch = ({ resetForm }) => {
    setSelectedSearchIndex(null);
    setSelectedSearchId(null);
    setFilterEditMode(false);
    removeButtonSelection();
    clearAll();
    resetForm();
  };
  const removeButtonSelection = () => {
    const buttons = document.querySelectorAll(`[id^="button-"]`);
    buttons.forEach((button) => {
      const parentDiv = button.parentElement;
      parentDiv.classList.add(classes.TableInnerFilter);
      parentDiv.classList.remove(classes.TableInnerFilterSelect);
    });
  };

  const cellsInCountryIndicator = (cellData) => {
    const updatedCellsByCountry = {};
    cellData.forEach(({ cellTitle, countryId }) => {
      const country = selectedCountryOption.find(({ id }) => id === countryId);
      if (country) {
        if (!updatedCellsByCountry[country.countryTitle]) {
          updatedCellsByCountry[country.countryTitle] = new Set([cellTitle]);
        } else {
          updatedCellsByCountry[country.countryTitle].add(cellTitle);
        }
      }
    });
    setCellsByCountryIndicator(updatedCellsByCountry);
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        exitFullscreen();
        setIsFocusMode(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  useEffect(() => {
    if (popoverRef.current) {
      const popoverWidth = popoverRef.current.parentElement.offsetWidth;
      const popoverTop = popoverRef.current.parentElement.offsetTop + scrollTop;
      const popoverLeft = popoverRef.current.parentElement.offsetLeft;

      setRankDataByWidth({ width: popoverWidth, top: popoverTop, left: popoverLeft });
    }
  }, [anchorPositions]);

  useEffect(() => {}, [filterSubmitted]);

  useEffect(() => {}, [selectedSortItem]);

  useEffect(() => {
    loadCountries();
  }, []);

  useEffect(() => {
    loadDeptForFilter();
  }, []);

  useEffect(() => {
    loadAllCellList();
  }, []);
  useEffect(() => {
    loadAllFilters();
  }, [openFilterRename]);

  useEffect(() => {
    cellsInCountryIndicator(selectedCellOption);
  }, [selectedCountryOption, selectedCellOption, selectedDepartmentOption, selectedFieldOption]);

  useEffect(() => {
    loadYearForFilter();
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !event.target.closest('#countryAutoComplete') &&
        !event.target.closest('#country-popup') &&
        !event.target.closest('#countryAutoCompleteMob')
      ) {
        // Clicked outside of .your-element-class, do something...countryAutoCompleteMob
        setOpenCountry(false);
        setOpenCountryClick(false);
      }
      if (event.target.closest('#countryAutoComplete')) {
        if (openCountry) {
          setOpenCountryClick(true);
        }

        if (openCountryClick && openCountry) {
          setOpenCountryClick(false);
          setOpenCountry(false);
        }
      }
    }

    // Attach the event listener on component mount
    window.addEventListener('click', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [openCountryClick, openCountry]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setScrollTop(scrollTop);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (allFinancialCompensationData?.length > 0) {
      const isNewEntry = updateArrayB(allFinancialCompensationData, reportData, selectedYear);
      if (!isNewEntry) {
        displayedFpData = selectedSortItem.sortField
          ? filteredFpData.slice(startFpIndex, endFpIndex)
          : filteredFpDataClone.slice(startFpIndex, endFpIndex) || [];
      }
    }
  }, [filteredFpData, selectedYear]);

  const updateArrayB = async (arrayA, arrayB, selectedYear) => {
    let isNewEntry = false;

    arrayA?.forEach((entryA, index) => {
      if (entryA.year === selectedYear) {
        const fullName = `${entryA.firstName} ${entryA.lastName}`;
        const indexB = arrayB.findIndex(
          (entryB) => entryB.employee.toLowerCase() === fullName?.toLowerCase(),
        );
        const { employeeId: empId, countryId } =
          fpData?.find((fpd) => {
            return fpd?.employee?.toLowerCase() === fullName?.toLowerCase();
          }) || {};

        if (index == 0 && indexB !== -1) {
          arrayB[indexB].salary = 0;
          arrayB[indexB].bonuses = 0;
        }

        if (indexB !== -1) {
          // Update existing entry in Array B
          arrayB[indexB].salary = parseFloat(arrayB[indexB].salary) + parseFloat(entryA.salary);
          arrayB[indexB].bonuses = parseFloat(arrayB[indexB].bonuses) + parseFloat(entryA.bonuses);
        } else {
          // Add new entry to Array B
          isNewEntry = true;
          arrayB.push({
            year: entryA.year,
            employee: `${entryA.firstName} ${entryA.lastName}`,
            employeeId: empId,
            countryId: countryId, // Assuming no countryId in Array A
            country: entryA.countryTitle,
            cell: entryA.cellTitle,
            department: entryA.departmentTitle,
            total: entryA.total,
            bonuses: entryA.bonuses,
            salary: entryA.salary,
            ranking: {
              fieldSelected: '',
              rankValue: 0, // Assuming default rankValue
            },
          });
        }
      }
    });
    if (isNewEntry) {
      setFpData((prevFpData) => {
        // Ensure no duplicates in fpData
        const updatedFpData = [...prevFpData, ...arrayB];
        const uniqueFpData = updatedFpData.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.employeeId === value.employeeId),
        );
        return uniqueFpData;
      });
    }
    return isNewEntry;
  };

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
    defaultMatches: true,
  });

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  const handleClickOpenFilter = () => {
    setOpenFilter(true);
  };
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSubmenuAnchorEl(null);
    setOpenFilterValidation(false);
  };
  const handleSubmenuClick = (event) => {
    setSubmenuAnchorEl(event.currentTarget); // Set anchor element for submenu
  };

  const handleSubmenuClose = () => {
    setSubmenuAnchorEl(null); // Close submenu by resetting the anchor element
  };
  return (
    <>
      <If condition={isFinAnalysisVisible && fpData}>
        {' '}
        <Grid
          container
          spacing={4}
          className={classes.QuarterlyMeetingObjectives}
          style={{ marginTop: 0 }}
        >
          <Grid item xs={12} className={classes.innercontent}>
            <Grid container style={{ height: '100%' }}>
              <Grid item xs={12}>
                <Grid container>
                  <Formik
                    enableReinitialize={false}
                    initialValues={{
                      countryid: [],
                      cellid: [],
                      yearid: yearListForFilter[yearListForFilter.length - 1]?.id,
                      period: 'fullYear',
                    }}
                    onSubmit={async (values, { resetForm }) => {
                      // const result = await getFinParamsUsers(values);
                      // fillReportState(result);
                      // //setFpData(result.usersResult);
                      // resetForm();
                    }}
                  >
                    {({
                      errors,
                      isSubmitting,
                      isValid,
                      dirty,
                      touched,
                      setFieldValue,
                      setFieldError,
                      setFieldTouched,
                      submitForm,
                      values,
                      resetForm,
                      handleBlur,
                      handleChange,
                    }) => {
                      return (
                        <>
                          <Box pb={2}>
                            <Grid container direction="row">
                              <Grid item xs={12} className={classes.FilterButtonMobile}>
                                <Box>
                                  <Button
                                    startIcon={<FilterListIcon />}
                                    color="primary"
                                    onClick={handleClickOpenFilter}
                                  >
                                    Filters
                                  </Button>
                                  <If condition={openFilter}>
                                    <Dialog
                                      fullScreen
                                      open={openFilter}
                                      onClose={handleCloseFilter}
                                      TransitionComponent={Transition}
                                    >
                                      <DialogTitle id="simple-dialog-title">
                                        <Box display="flex" justifyContent="space-between">
                                          <Box
                                            onClick={() => {
                                              resetForm();
                                              clearAll();
                                              removeButtonSelection();
                                            }}
                                          >
                                            Clear All
                                          </Box>
                                          <Box>
                                            <b>Filters</b>
                                          </Box>
                                          <Box onClick={handleCloseFilter}>Cancel</Box>
                                        </Box>
                                      </DialogTitle>
                                      <DialogContent>
                                        <Grid container spacing={2}>
                                          <Grid
                                            item
                                            xs={12}
                                            className={classes.FilterDropdownWidthSelectMob}
                                          >
                                            <Autocomplete
                                              multiple
                                              id="fieldsOptions-mob"
                                              disableCloseOnSelect
                                              options={[SelectAllFields, ...fieldOptions]}
                                              getOptionLabel={(option) => {
                                                return option?.label;
                                              }}
                                              onChange={(event, newValue) => {
                                                newValue.length === 0 &&
                                                  setSelectedFieldOption(newValue);
                                              }}
                                              renderTags={() => {}}
                                              renderOption={(option, { selected }) => {
                                                return (
                                                  <React.Fragment>
                                                    {option === SelectAllFields ? (
                                                      <FormControlLabel
                                                        control={
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={
                                                              selectedFieldOption.length ===
                                                              fieldOptions.length
                                                            }
                                                          />
                                                        }
                                                        label={option.label}
                                                        onChange={(event) => {
                                                          if (event.target.checked) {
                                                            setSelectedFieldOption(fieldOptions);
                                                            const fieldOptioIdValues = fieldOptions.map(
                                                              (field) => {
                                                                return field.value;
                                                              },
                                                            );
                                                            setFieldValue(
                                                              'fieldoptionid',
                                                              fieldOptioIdValues || [],
                                                            );
                                                          } else {
                                                            setFieldValue('fieldoptionid', []);
                                                            setSelectedFieldOption([]);
                                                          }
                                                        }}
                                                      />
                                                    ) : (
                                                      <FormControlLabel
                                                        control={
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={selectedFieldOption.some(
                                                              (selectedOption) =>
                                                                selectedOption.value ===
                                                                option.value,
                                                            )}
                                                            onChange={() => {
                                                              setIsApplyClicked(false);
                                                              const isSelected = selectedFieldOption.some(
                                                                (selectedOption) =>
                                                                  selectedOption.value ===
                                                                  option.value,
                                                              );

                                                              let newSelectedOptions = [];

                                                              if (isSelected) {
                                                                newSelectedOptions = selectedFieldOption.filter(
                                                                  (selectedOption) =>
                                                                    selectedOption.value !==
                                                                    option.value,
                                                                );
                                                              } else {
                                                                newSelectedOptions = [
                                                                  ...selectedFieldOption,
                                                                  option,
                                                                ];
                                                              }

                                                              setSelectedFieldOption(
                                                                newSelectedOptions,
                                                              );

                                                              const fieldOptioIdValues = newSelectedOptions.map(
                                                                (field) => {
                                                                  return field.value;
                                                                },
                                                              );
                                                              setFieldValue(
                                                                'fieldoptionid',
                                                                fieldOptioIdValues || [],
                                                              );
                                                            }}
                                                          />
                                                        }
                                                        label={option.label}
                                                      />
                                                    )}
                                                  </React.Fragment>
                                                );
                                              }}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  name="fieldoptionid"
                                                  variant="outlined"
                                                  label={
                                                    selectedFieldOption.length > 1 &&
                                                    selectedFieldOption.length <=
                                                      fieldOptions.length
                                                      ? 'Multiple Metrics'
                                                      : selectedFieldOption.length == 1
                                                      ? selectedFieldOption[0].label
                                                      : 'Select Metric'
                                                  }
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            className={classes.FilterDropdownWidthSelectMob}
                                          >
                                            <div id="countryAutoCompleteMob">
                                              <Autocomplete
                                                multiple
                                                id="country-mob"
                                                disableCloseOnSelect
                                                options={[SelectAllCountries, ...countryList]}
                                                getOptionLabel={(option) => {
                                                  return option?.countryTitle;
                                                }}
                                                onChange={(event, newValue) => {
                                                  if (newValue.length == 0) {
                                                    setCellListForFilter(copyCellListForFilter);
                                                  }

                                                  newValue.length === 0 &&
                                                    setSelectedCountryOption(newValue);
                                                }}
                                                renderTags={() => {}}
                                                renderOption={(option, { selected }) => (
                                                  <React.Fragment>
                                                    {option === SelectAllCountries ? (
                                                      <FormControlLabel
                                                        control={
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={
                                                              selectedCountryOption.length ===
                                                              countryList.length
                                                            }
                                                          />
                                                        }
                                                        label={option.countryTitle}
                                                        onChange={(event) => {
                                                          if (event.target.checked) {
                                                            setSelectedCountryOption(countryList);
                                                            setFieldValue(
                                                              'countryid',
                                                              countryList || [],
                                                            );
                                                            loadCellsForFilter(
                                                              selectedCountryOption || [],
                                                            );
                                                          } else {
                                                            setFieldValue('countryid', []);
                                                            setSelectedCountryOption([]);
                                                            loadCellsForFilter(
                                                              selectedCountryOption || [],
                                                            );
                                                          }
                                                        }}
                                                      />
                                                    ) : (
                                                      <FormControlLabel
                                                        control={
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={selectedCountryOption.some(
                                                              (selectedOption) =>
                                                                selectedOption.countryTitle ===
                                                                option.countryTitle,
                                                            )}
                                                            onChange={() => {
                                                              setIsApplyClicked(false);
                                                              const isSelected = selectedCountryOption.some(
                                                                (selectedOption) =>
                                                                  selectedOption.countryTitle ===
                                                                  option.countryTitle,
                                                              );

                                                              let newSelectedOptions = [];

                                                              if (isSelected) {
                                                                newSelectedOptions = selectedCountryOption.filter(
                                                                  (selectedOption) =>
                                                                    selectedOption.countryTitle !==
                                                                    option.countryTitle,
                                                                );
                                                              } else {
                                                                newSelectedOptions = [
                                                                  ...selectedCountryOption,
                                                                  option,
                                                                ];
                                                              }

                                                              setSelectedCountryOption(
                                                                newSelectedOptions,
                                                              );
                                                              setFieldValue(
                                                                'countryid',
                                                                newSelectedOptions || [],
                                                              );
                                                              loadCellsForFilter(
                                                                newSelectedOptions || [],
                                                              );
                                                            }}
                                                          />
                                                        }
                                                        label={option.countryTitle}
                                                      />
                                                    )}
                                                  </React.Fragment>
                                                )}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    name="countryid"
                                                    variant="outlined"
                                                    label={
                                                      selectedCountryOption.length > 1 &&
                                                      selectedCountryOption.length <=
                                                        countryList.length
                                                        ? 'Multiple Countries'
                                                        : selectedCountryOption.length == 1
                                                        ? selectedCountryOption[0].countryTitle
                                                        : 'Select Country'
                                                    }
                                                  />
                                                )}
                                                popupIcon={<ExpandMoreIcon />}
                                              />
                                            </div>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            className={classes.FilterDropdownWidthSelectMob}
                                          >
                                            <Autocomplete
                                              multiple
                                              id="cells-mob"
                                              disableCloseOnSelect
                                              options={[SelectAllCells, ...cellListForFilter]}
                                              getOptionLabel={(option) => {
                                                return option?.cellTitle;
                                              }}
                                              onChange={(event, newValue) => {
                                                newValue.length === 0 &&
                                                  setSelectedCellOption(newValue);
                                              }}
                                              renderTags={() => {}}
                                              renderOption={(option, { selected }) => (
                                                <React.Fragment>
                                                  {option === SelectAllCells ? (
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          icon={icon}
                                                          checkedIcon={checkedIcon}
                                                          style={{ marginRight: 8 }}
                                                          checked={
                                                            selectedCellOption.length ===
                                                            cellListForFilter.length
                                                          }
                                                        />
                                                      }
                                                      label={option.cellTitle}
                                                      onChange={(event) => {
                                                        if (event.target.checked) {
                                                          setSelectedCellOption(cellListForFilter);
                                                          setFieldValue(
                                                            'cellid',
                                                            cellListForFilter || [],
                                                          );
                                                        } else {
                                                          setFieldValue('cellid', []);
                                                          setSelectedCellOption([]);
                                                        }
                                                      }}
                                                    />
                                                  ) : (
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          icon={icon}
                                                          checkedIcon={checkedIcon}
                                                          style={{ marginRight: 8 }}
                                                          checked={selectedCellOption.some(
                                                            (selectedOption) =>
                                                              selectedOption.cellTitle ===
                                                              option.cellTitle,
                                                          )}
                                                          onChange={() => {
                                                            setIsApplyClicked(false);
                                                            const isSelected = selectedCellOption.some(
                                                              (selectedOption) =>
                                                                selectedOption.cellTitle ===
                                                                option.cellTitle,
                                                            );

                                                            let newSelectedOptions = [];

                                                            if (isSelected) {
                                                              newSelectedOptions = selectedCellOption.filter(
                                                                (selectedOption) =>
                                                                  selectedOption.cellTitle !==
                                                                  option.cellTitle,
                                                              );
                                                            } else {
                                                              newSelectedOptions = [
                                                                ...selectedCellOption,
                                                                option,
                                                              ];
                                                            }

                                                            setSelectedCellOption(
                                                              newSelectedOptions,
                                                            );
                                                            setFieldValue(
                                                              'cellid',
                                                              newSelectedOptions || [],
                                                            );
                                                          }}
                                                        />
                                                      }
                                                      label={option.cellTitle}
                                                    />
                                                  )}
                                                </React.Fragment>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  name="cellid"
                                                  variant="outlined"
                                                  label={
                                                    selectedCellOption.length > 1 &&
                                                    selectedCellOption.length <=
                                                      cellListForFilter.length
                                                      ? 'Multiple Cells'
                                                      : selectedCellOption.length == 1
                                                      ? selectedCellOption[0].cellTitle
                                                      : 'Select Cell'
                                                  }
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            className={classes.FilterDropdownWidthSelectMob}
                                          >
                                            <Autocomplete
                                              multiple
                                              id="departments"
                                              disableCloseOnSelect
                                              options={[SelectAllDepartments, ...deptListForFilter]}
                                              getOptionLabel={(option) => {
                                                return option?.department;
                                              }}
                                              onChange={(event, newValue) => {
                                                newValue.length === 0 &&
                                                  setSelectedDepartmentOption(newValue);
                                              }}
                                              renderTags={() => {}}
                                              renderOption={(option, { selected }) => (
                                                <React.Fragment>
                                                  {option === SelectAllDepartments ? (
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          icon={icon}
                                                          checkedIcon={checkedIcon}
                                                          style={{ marginRight: 8 }}
                                                          checked={
                                                            selectedDepartmentOption.length ===
                                                            deptListForFilter.length
                                                          }
                                                        />
                                                      }
                                                      label={option.department}
                                                      onChange={(event) => {
                                                        if (event.target.checked) {
                                                          setSelectedDepartmentOption(
                                                            deptListForFilter,
                                                          );
                                                          setFieldValue(
                                                            'deptid',
                                                            deptListForFilter || [],
                                                          );
                                                        } else {
                                                          setFieldValue('deptid', []);
                                                          setSelectedDepartmentOption([]);
                                                        }
                                                      }}
                                                    />
                                                  ) : (
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          icon={icon}
                                                          checkedIcon={checkedIcon}
                                                          style={{ marginRight: 8 }}
                                                          checked={selectedDepartmentOption.some(
                                                            (selectedOption) =>
                                                              selectedOption.department ===
                                                              option.department,
                                                          )}
                                                          onChange={() => {
                                                            setIsApplyClicked(false);
                                                            const isSelected = selectedDepartmentOption.some(
                                                              (selectedOption) =>
                                                                selectedOption.department ===
                                                                option.department,
                                                            );

                                                            let newSelectedOptions = [];

                                                            if (isSelected) {
                                                              newSelectedOptions = selectedDepartmentOption.filter(
                                                                (selectedOption) =>
                                                                  selectedOption.department !==
                                                                  option.department,
                                                              );
                                                            } else {
                                                              newSelectedOptions = [
                                                                ...selectedDepartmentOption,
                                                                option,
                                                              ];
                                                            }

                                                            setSelectedDepartmentOption(
                                                              newSelectedOptions,
                                                            );
                                                            setFieldValue(
                                                              'deptid',
                                                              newSelectedOptions || [],
                                                            );
                                                          }}
                                                        />
                                                      }
                                                      label={option.department}
                                                    />
                                                  )}
                                                </React.Fragment>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  name="deptid"
                                                  variant="outlined"
                                                  label={
                                                    selectedDepartmentOption.length > 1 &&
                                                    selectedDepartmentOption.length <=
                                                      deptListForFilter.length
                                                      ? 'Multiple Departments'
                                                      : selectedDepartmentOption.length == 1
                                                      ? selectedDepartmentOption[0].department
                                                      : 'Select Department'
                                                  }
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>
                                          <Grid item xs={12}>
                                            <Autocomplete
                                              disablePortal={true}
                                              options={yearListForFilter}
                                              getOptionLabel={(option) => option?.year}
                                              getOptionSelected={(option, value) =>
                                                option?.id === value?.id
                                              }
                                              //value={defaultYearForFilter.length > 0 && defaultYearForFilter}
                                              value={
                                                yearListForFilter.length > 0 && !values?.yearid
                                                  ? yearListForFilter[yearListForFilter.length - 1]
                                                  : values?.yearid
                                                  ? yearListForFilter.find(
                                                      (d) => d?.id === values?.yearid,
                                                    )
                                                  : null
                                              }
                                              onChange={(e, value) => {
                                                setFieldValue('yearid', value?.id || '');
                                                setFieldTouched('yearid');
                                              }}
                                              renderOption={(option, { selected }) => (
                                                <RadioGroup>
                                                  <FormControlLabel
                                                    value={option.id}
                                                    control={<Radio checked={selected} />}
                                                    label={option.year}
                                                  />
                                                </RadioGroup>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  name="yearid"
                                                  variant="outlined"
                                                  label="Year"
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>
                                          <Grid item xs={12}>
                                            <Autocomplete
                                              id="period-autocomplete-mob"
                                              options={periodOptions}
                                              disablePortal={true}
                                              getOptionLabel={(option) => option.label}
                                              getOptionSelected={(option, value) =>
                                                option.value === periodOptions[0].value &&
                                                option?.label === value?.label
                                              }
                                              value={
                                                periodOptions.length > 0
                                                  ? periodOptions.find((d) => {
                                                      if (d.value === periodOptions[0].value) {
                                                        d?.label === values?.label;
                                                      } else {
                                                        return;
                                                      }
                                                    })
                                                  : null
                                              }
                                              onChange={(e, value) => {
                                                if (value.value == 'fullYear') {
                                                  setFieldValue('period', value?.value || '');
                                                  setFieldTouched('period');
                                                }
                                              }}
                                              renderOption={(option, { selected }) => {
                                                return (
                                                  <RadioGroup>
                                                    <FormControlLabel
                                                      value={option.id}
                                                      control={<Radio checked={selected} />}
                                                      label={option.label}
                                                      disabled={
                                                        !selected && option !== periodOptions[0]
                                                      }
                                                    />
                                                  </RadioGroup>
                                                );
                                              }}
                                              renderInput={(params) => {
                                                return (
                                                  <TextField
                                                    {...params}
                                                    label="Period"
                                                    variant="outlined"
                                                  />
                                                );
                                              }}
                                              popupIcon={<ExpandMoreIcon />}
                                              defaultValue={periodOptions[0]}
                                            />
                                          </Grid>
                                        </Grid>
                                      </DialogContent>
                                      <DialogActions>
                                        <Button
                                          type="submit"
                                          variant="contained"
                                          color="primary"
                                          onClick={async () => {
                                            setIsApplyClicked(true);
                                            //removeButtonSelection();
                                            // setFilterEditMode(true);
                                            if (values?.fieldoptionid) {
                                              const mergedFilterSearch = mergeObjects(
                                                values,
                                                filterSubmitted,
                                              );

                                              const loadedFpData = await loadFpData();

                                              fillReportState(
                                                loadedFpData,
                                                yearListForFilter.find(
                                                  (d) => d?.id === selectedYear,
                                                )?.year,
                                              );
                                              if (values['yearid'] === undefined) {
                                                values['yearid'] =
                                                  yearListForFilter.length > 0
                                                    ? yearListForFilter[
                                                        yearListForFilter.length - 1
                                                      ]?.id
                                                    : '';

                                                setSelectedYear(values['yearid']);
                                              }

                                              updateArrayB(
                                                allFinancialCompensationData,
                                                filteredFpData,
                                                yearListForFilter.find(
                                                  (d) => d?.id === selectedYear,
                                                )?.year,
                                              );

                                              setFilterSubmitted(values);
                                              setLoaded(filterFpData(values));
                                            }
                                          }}
                                          fullWidth
                                        >
                                          Apply
                                        </Button>
                                      </DialogActions>
                                    </Dialog>
                                  </If>
                                </Box>
                              </Grid>
                              <Grid item xs={12} className={classes.FilterDesktop}>
                                <Grid container spacing={2} className={classes.AutoCompleteDisable}>
                                  <Grid item className={classes.FilterDropdownWidthSelect}>
                                    <Autocomplete
                                      multiple
                                      id="fieldsOptions"
                                      disableCloseOnSelect
                                      options={[SelectAllFields, ...fieldOptions]}
                                      getOptionLabel={(option) => {
                                        return option?.label;
                                      }}
                                      onChange={(event, newValue) => {
                                        setIsApplyClicked(false);
                                        newValue.length === 0 && setSelectedFieldOption(newValue);
                                      }}
                                      renderTags={() => {}}
                                      renderOption={(option, { selected }) => {
                                        return (
                                          <React.Fragment>
                                            {option === SelectAllFields ? (
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={
                                                      selectedFieldOption.length ===
                                                      fieldOptions.length
                                                    }
                                                  />
                                                }
                                                label={option.label}
                                                onChange={(event) => {
                                                  if (event.target.checked) {
                                                    setSelectedFieldOption(fieldOptions);
                                                    const fieldOptioIdValues = fieldOptions.map(
                                                      (field) => {
                                                        return field.value;
                                                      },
                                                    );
                                                    setFieldValue(
                                                      'fieldoptionid',
                                                      fieldOptioIdValues || [],
                                                    );
                                                  } else {
                                                    setFieldValue('fieldoptionid', []);
                                                    setSelectedFieldOption([]);
                                                  }
                                                }}
                                              />
                                            ) : (
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selectedFieldOption.some(
                                                      (selectedOption) =>
                                                        selectedOption.value === option.value,
                                                    )}
                                                    onChange={() => {
                                                      setIsApplyClicked(false);
                                                      const isSelected = selectedFieldOption.some(
                                                        (selectedOption) =>
                                                          selectedOption.value === option.value,
                                                      );

                                                      let newSelectedOptions = [];

                                                      if (isSelected) {
                                                        newSelectedOptions = selectedFieldOption.filter(
                                                          (selectedOption) =>
                                                            selectedOption.value !== option.value,
                                                        );
                                                      } else {
                                                        newSelectedOptions = [
                                                          ...selectedFieldOption,
                                                          option,
                                                        ];
                                                      }

                                                      setSelectedFieldOption(newSelectedOptions);

                                                      const fieldOptioIdValues = newSelectedOptions.map(
                                                        (field) => {
                                                          return field.value;
                                                        },
                                                      );
                                                      setFieldValue(
                                                        'fieldoptionid',
                                                        fieldOptioIdValues || [],
                                                      );
                                                    }}
                                                  />
                                                }
                                                label={option.label}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                }}
                                              />
                                            )}
                                          </React.Fragment>
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="fieldoptionid"
                                          variant="outlined"
                                          label={
                                            selectedFieldOption.length > 1 &&
                                            selectedFieldOption.length <= fieldOptions.length
                                              ? 'Multiple Metrics'
                                              : selectedFieldOption.length == 1
                                              ? selectedFieldOption[0].label
                                              : 'Select Metric'
                                          }
                                        />
                                      )}
                                      popupIcon={<ExpandMoreIcon />}
                                    />
                                  </Grid>
                                  <Grid item className={classes.FilterDropdownWidthSelect}>
                                    <div id="countryAutoComplete">
                                      <Autocomplete
                                        multiple
                                        id="country"
                                        open={openCountry}
                                        // onOpen={() => setOpenCountry(true)}
                                        onOpen={() => handleToggleOpen('open')}
                                        //onClose={() => handleToggleOpen('close')}
                                        disableCloseOnSelect
                                        options={[SelectAllCountries, ...countryList]}
                                        getOptionLabel={(option) => {
                                          return option?.countryTitle;
                                        }}
                                        onChange={(event, newValue) => {
                                          if (newValue.length == 0) {
                                            setCellListForFilter(copyCellListForFilter);
                                          }
                                          // setFilterEditMode(true);
                                          handleToggleOpen('changeEvent');
                                          // setSelectedCountryOption(newValue);
                                          newValue.length === 0 &&
                                            setSelectedCountryOption(newValue);
                                        }}
                                        renderTags={() => {}}
                                        renderOption={(option, { selected }) => (
                                          <React.Fragment>
                                            {option === SelectAllCountries ? (
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={
                                                      selectedCountryOption.length ===
                                                      countryList.length
                                                    }
                                                  />
                                                }
                                                label={option.countryTitle}
                                                onChange={(event) => {
                                                  if (event.target.checked) {
                                                    setSelectedCountryOption(countryList);
                                                    setFieldValue('countryid', countryList || []);
                                                    loadCellsForFilter(countryList || []);
                                                  } else {
                                                    setFieldValue('countryid', []);
                                                    setSelectedCountryOption([]);
                                                    loadCellsForFilter(selectedCountryOption || []);
                                                  }
                                                }}
                                              />
                                            ) : (
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selectedCountryOption.some(
                                                      (selectedOption) =>
                                                        selectedOption.countryTitle ===
                                                        option.countryTitle,
                                                    )}
                                                    onChange={() => {
                                                      setIsApplyClicked(false);
                                                      const isSelected = selectedCountryOption.some(
                                                        (selectedOption) =>
                                                          selectedOption.countryTitle ===
                                                          option.countryTitle,
                                                      );

                                                      let newSelectedOptions = [];

                                                      if (isSelected) {
                                                        newSelectedOptions = selectedCountryOption.filter(
                                                          (selectedOption) =>
                                                            selectedOption.countryTitle !==
                                                            option.countryTitle,
                                                        );
                                                      } else {
                                                        newSelectedOptions = [
                                                          ...selectedCountryOption,
                                                          option,
                                                        ];
                                                      }

                                                      setSelectedCountryOption(newSelectedOptions);
                                                      setFieldValue(
                                                        'countryid',
                                                        newSelectedOptions || [],
                                                      );
                                                      loadCellsForFilter(newSelectedOptions || []);
                                                      setOpenCountry(true);
                                                    }}
                                                  />
                                                }
                                                label={
                                                  <Typography onClick={(e) => e.stopPropagation()}>
                                                    {option.countryTitle}
                                                  </Typography>
                                                }
                                              />
                                            )}
                                          </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            name="countryid"
                                            variant="outlined"
                                            label={
                                              selectedCountryOption.length > 1 &&
                                              selectedCountryOption.length <= countryList.length
                                                ? 'Multiple Countries'
                                                : selectedCountryOption.length == 1
                                                ? selectedCountryOption[0].countryTitle
                                                : 'Select Country'
                                            }
                                            // label={
                                            //   selectedCountryOption.length === countryList.length
                                            //     ? 'Multiple Countries'
                                            //     : 'Select Country'
                                            // }
                                          />
                                        )}
                                        popupIcon={<ExpandMoreIcon />}
                                      />
                                    </div>
                                  </Grid>

                                  <Grid item className={classes.FilterDropdownWidthSelect}>
                                    <Autocomplete
                                      multiple
                                      id="cells"
                                      disableCloseOnSelect
                                      options={[SelectAllCells, ...cellListForFilter]}
                                      getOptionLabel={(option) => {
                                        return option?.cellTitle;
                                      }}
                                      onChange={(event, newValue) => {
                                        newValue.length === 0 && setSelectedCellOption(newValue);
                                      }}
                                      renderTags={() => {}}
                                      renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                          {option === SelectAllCells ? (
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={
                                                    selectedCellOption.length ===
                                                    cellListForFilter.length
                                                  }
                                                />
                                              }
                                              label={option.cellTitle}
                                              onChange={(event) => {
                                                if (event.target.checked) {
                                                  setSelectedCellOption(cellListForFilter);
                                                  setFieldValue('cellid', cellListForFilter || []);
                                                } else {
                                                  setFieldValue('cellid', []);
                                                  setSelectedCellOption([]);
                                                }
                                              }}
                                            />
                                          ) : (
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={selectedCellOption.some(
                                                    (selectedOption) =>
                                                      selectedOption.cellTitle === option.cellTitle,
                                                  )}
                                                  onChange={() => {
                                                    setIsApplyClicked(false);
                                                    const isSelected = selectedCellOption.some(
                                                      (selectedOption) =>
                                                        selectedOption.cellTitle ===
                                                        option.cellTitle,
                                                    );

                                                    let newSelectedOptions = [];

                                                    if (isSelected) {
                                                      newSelectedOptions = selectedCellOption.filter(
                                                        (selectedOption) =>
                                                          selectedOption.cellTitle !==
                                                          option.cellTitle,
                                                      );
                                                    } else {
                                                      newSelectedOptions = [
                                                        ...selectedCellOption,
                                                        option,
                                                      ];
                                                    }

                                                    setSelectedCellOption(newSelectedOptions);
                                                    setFieldValue(
                                                      'cellid',
                                                      newSelectedOptions || [],
                                                    );
                                                  }}
                                                />
                                              }
                                              label={option.cellTitle}
                                            />
                                          )}
                                        </React.Fragment>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="cellid"
                                          variant="outlined"
                                          label={
                                            selectedCellOption.length > 1 &&
                                            selectedCellOption.length <= cellListForFilter.length
                                              ? 'Multiple Cells'
                                              : selectedCellOption.length == 1
                                              ? selectedCellOption[0].cellTitle
                                              : 'Select Cell'
                                          }
                                        />
                                      )}
                                      popupIcon={<ExpandMoreIcon />}
                                    />
                                  </Grid>
                                  <Grid item className={classes.FilterDropdownWidthSelect}>
                                    <Autocomplete
                                      multiple
                                      id="departments"
                                      disableCloseOnSelect
                                      options={[SelectAllDepartments, ...deptListForFilter]}
                                      getOptionLabel={(option) => {
                                        return option?.department;
                                      }}
                                      onChange={(event, newValue) => {
                                        newValue.length === 0 &&
                                          setSelectedDepartmentOption(newValue);
                                      }}
                                      renderTags={() => {}}
                                      renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                          {option === SelectAllDepartments ? (
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={
                                                    selectedDepartmentOption.length ===
                                                    deptListForFilter.length
                                                  }
                                                />
                                              }
                                              label={option.department}
                                              onChange={(event) => {
                                                if (event.target.checked) {
                                                  setSelectedDepartmentOption(deptListForFilter);
                                                  setFieldValue('deptid', deptListForFilter || []);
                                                } else {
                                                  setFieldValue('deptid', []);
                                                  setSelectedDepartmentOption([]);
                                                }
                                              }}
                                            />
                                          ) : (
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={selectedDepartmentOption.some(
                                                    (selectedOption) =>
                                                      selectedOption.department ===
                                                      option.department,
                                                  )}
                                                  onChange={() => {
                                                    setIsApplyClicked(false);
                                                    const isSelected = selectedDepartmentOption.some(
                                                      (selectedOption) =>
                                                        selectedOption.department ===
                                                        option.department,
                                                    );

                                                    let newSelectedOptions = [];

                                                    if (isSelected) {
                                                      newSelectedOptions = selectedDepartmentOption.filter(
                                                        (selectedOption) =>
                                                          selectedOption.department !==
                                                          option.department,
                                                      );
                                                    } else {
                                                      newSelectedOptions = [
                                                        ...selectedDepartmentOption,
                                                        option,
                                                      ];
                                                    }

                                                    setSelectedDepartmentOption(newSelectedOptions);
                                                    setFieldValue(
                                                      'deptid',
                                                      newSelectedOptions || [],
                                                    );
                                                  }}
                                                />
                                              }
                                              label={option.department}
                                            />
                                          )}
                                        </React.Fragment>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="deptid"
                                          variant="outlined"
                                          label={
                                            selectedDepartmentOption.length > 1 &&
                                            selectedDepartmentOption.length <=
                                              deptListForFilter.length
                                              ? 'Multiple Departments'
                                              : selectedDepartmentOption.length == 1
                                              ? selectedDepartmentOption[0].department
                                              : 'Select Department'
                                          }
                                          // label={
                                          //   selectedDepartmentOption.length ===
                                          //   deptListForFilter.length
                                          //     ? 'Multiple Departments'
                                          //     : 'Select Department'
                                          // }
                                        />
                                      )}
                                      popupIcon={<ExpandMoreIcon />}
                                    />
                                  </Grid>

                                  <Grid item className={classes.FilterDropdownWidth}>
                                    <Autocomplete
                                      options={yearListForFilter}
                                      getOptionLabel={(option) => option?.year}
                                      getOptionSelected={(option, value) =>
                                        option?.id === value?.id
                                      }
                                      //value={defaultYearForFilter.length > 0 && defaultYearForFilter}
                                      value={
                                        yearListForFilter.length > 0 && !values?.yearid
                                          ? yearListForFilter[yearListForFilter.length - 1]
                                          : values?.yearid
                                          ? yearListForFilter.find((d) => d?.id === values?.yearid)
                                          : null
                                      }
                                      defaultYear={yearListForFilter[yearListForFilter.length - 1]}
                                      onChange={(e, value) => {
                                        setFieldValue('yearid', value?.id || '');
                                        setFieldTouched('yearid');
                                        setSelectedYear(value?.id);
                                      }}
                                      renderOption={(option, { selected }) => (
                                        <RadioGroup>
                                          <FormControlLabel
                                            value={option.id}
                                            control={<Radio checked={selected} />}
                                            label={option.year}
                                          />
                                        </RadioGroup>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="yearid"
                                          variant="outlined"
                                          label="Year"
                                        />
                                      )}
                                      popupIcon={<ExpandMoreIcon />}
                                    />
                                  </Grid>
                                  <Grid item className={classes.FilterDropdownWidth}>
                                    <Autocomplete
                                      id="period-autocomplete"
                                      options={periodOptions}
                                      getOptionLabel={(option) => option.label}
                                      getOptionDisabled={(option) => option !== periodOptions[0]}
                                      getOptionSelected={(option, value) =>
                                        option.value === periodOptions[0].value &&
                                        option?.label === value?.label
                                      }
                                      value={
                                        periodOptions.length > 0
                                          ? periodOptions.find((d) => {
                                              if (d.value == 'fullYear') {
                                                d?.label === values?.label;
                                              } else {
                                                return;
                                              }
                                            })
                                          : null
                                      }
                                      onChange={(e, value) => {
                                        if (value?.value === 'fullYear') {
                                          setFieldValue('period', value?.value || '');
                                          setFieldTouched('period');
                                        } else {
                                          return;
                                        }
                                      }}
                                      renderOption={(option, { selected }) => {
                                        return (
                                          <RadioGroup>
                                            <FormControlLabel
                                              value={option.id}
                                              control={<Radio checked={selected} />}
                                              label={option.label}
                                              disabled={!selected && option !== periodOptions[0]}
                                            />
                                          </RadioGroup>
                                        );
                                      }}
                                      renderInput={(params) => {
                                        return (
                                          <TextField
                                            {...params}
                                            label="Period"
                                            variant="outlined"
                                          />
                                        );
                                      }}
                                      popupIcon={<ExpandMoreIcon />}
                                      defaultValue={periodOptions[0]}
                                    />
                                  </Grid>

                                  <Grid item>
                                    <Button
                                      type="submit"
                                      className={classes.button}
                                      variant="outlined"
                                      onClick={async () => {
                                        setLoaded(false);
                                        setIsApplyClicked(true);
                                        setLoaded(false);
                                        !filterEditMode && removeButtonSelection();

                                        if (values?.fieldoptionid) {
                                          const mergedFilterSearch = mergeObjects(
                                            values,
                                            filterSubmitted,
                                          );

                                          let loadedFpData = await loadFpData();
                                          // fillReportState(
                                          //   loadedFpData,
                                          //   yearListForFilter.find((d) => d?.id === selectedYear)
                                          //     ?.year,
                                          // );
                                          // if (values['yearid'] === undefined) {
                                          //   values['yearid'] =
                                          //     yearListForFilter.length > 0
                                          //       ? yearListForFilter[yearListForFilter.length - 1]
                                          //           ?.id
                                          //       : '';
                                          //   setSelectedYear(values['yearid']);
                                          // }
                                          // updateArrayB(
                                          //   allFinancialCompensationData,
                                          //   filteredFpData,
                                          //   yearListForFilter.find((d) => d?.id === selectedYear)
                                          //     ?.year,
                                          // );
                                          const updateStateAndArray = async () => {
                                            await fillReportState(
                                              loadedFpData,
                                              yearListForFilter.find((d) => d?.id === selectedYear)
                                                ?.year,
                                            );

                                            if (values['yearid'] === undefined) {
                                              values['yearid'] =
                                                yearListForFilter.length > 0
                                                  ? yearListForFilter[yearListForFilter.length - 1]
                                                      ?.id
                                                  : '';
                                              setSelectedYear(values['yearid']);
                                            }

                                            updateArrayB(
                                              allFinancialCompensationData,
                                              filteredFpData,
                                              yearListForFilter.find((d) => d?.id === selectedYear)
                                                ?.year,
                                            );
                                          };

                                          // Call the async function
                                          updateStateAndArray();
                                          setFilterSubmitted(values);
                                          setLoaded(filterFpData(values));
                                        }
                                      }}
                                    >
                                      Apply
                                    </Button>
                                    {isSubmitting && (
                                      <CircularProgress
                                        size={24}
                                        className={classes.buttonProgress}
                                      />
                                    )}
                                  </Grid>
                                  <Grid item>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      height={1}
                                      className={classes.clearbtn}
                                      onClick={() => {
                                        resetForm();
                                        filterFpData({
                                          country: null,
                                          cell: null,
                                        });
                                        // filterFpData();
                                        setSelectedCountryOption([]);
                                        setSelectedCellOption([]);
                                        setSelectedDepartmentOption([]);
                                        setSelectedFieldOption([]);
                                        setOpenFilter(false);
                                        setIsApplyClicked(false);
                                        clearSelectedSearch({ resetForm });
                                      }}
                                    >
                                      CLEAR
                                    </Box>
                                  </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                  <Dialog
                                    open={openFilterName}
                                    onClose={handleCloseFilterName}
                                    className={classes.dialogOuterMedium}
                                    fullScreen={fullScreen}
                                    aria-labelledby="responsive-dialog-title"
                                  >
                                    <DialogTitle
                                      className={classes.dialogTitle}
                                      id="responsive-dialog-title"
                                    >
                                      <Typography variant="h2" noWrap component="span">
                                        {`Save search as:`}
                                      </Typography>
                                      <IconButton
                                        aria-label="close"
                                        onClick={handleCloseFilterName}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </DialogTitle>
                                    <DialogContent>
                                      <TextField
                                        autoFocus
                                        margin="dense"
                                        label="Type here..."
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={filterName}
                                        onChange={(e) => {
                                          setFilterName(e.target.value);
                                          setFilterNameValid(true);
                                        }}
                                        error={!isFilterNameValid}
                                        helperText={!isFilterNameValid && 'Required field missing'}
                                      />
                                    </DialogContent>

                                    <DialogActions>
                                      <Button
                                        onClick={async () => {
                                          if (filterEditMode) {
                                            setFilterNameValid(false);
                                            setFilterSubmitted(values);
                                            if (
                                              values['yearid'] &&
                                              values['fieldoptionid'] &&
                                              selectedSearchId
                                            ) {
                                              const filterObj = {
                                                id: selectedSearchId,
                                                metrics: values['fieldoptionid'] || [],
                                                country: values['countryid'] || [],
                                                cell: values['cellid'] || [],
                                                department: values['deptid'] || [],
                                                year: values['yearid'] || '',
                                                period: values['period'] || '',
                                              };
                                              setSelectedYear(values['yearid']);
                                              const result = await updateSavedFilter(filterObj);
                                              if (result) {
                                                handleCloseFilterName();
                                              }
                                            } else {
                                            }
                                          } else {
                                            if (filterName.trim() === '') {
                                              setFilterNameValid(false);
                                            } else {
                                              // Perform your save action here
                                              setAnchorEl(null);
                                              const filterObj = {
                                                userId: loggedInUserData?.id || null,
                                                metrics: values['fieldoptionid'] || [],
                                                filterName: filterName,
                                                country: values['countryid'] || [],
                                                cell: values['cellid'] || [],
                                                department: values['deptid'] || [],
                                                year: values['yearid'] || '',
                                                period: values['period'] || '',
                                              };
                                              setSelectedYear(values['yearid']);
                                              const result = await saveFilter(filterObj);

                                              if (result) {
                                                loadAllFilters();

                                                setSelectedSearchIndex(null);
                                                setSelectedSearchId(null);
                                              }
                                              handleCloseFilterName();
                                            }
                                          }
                                        }}
                                        color="primary"
                                        variant="contained"
                                        autoFocus
                                      >
                                        Save
                                      </Button>
                                      <Button
                                        onClick={handleCloseFilterName}
                                        className={classes.secondaryBtnUI}
                                        variant="outlined"
                                        color="secondary"
                                      >
                                        Cancel
                                      </Button>
                                    </DialogActions>
                                  </Dialog>
                                  <Dialog
                                    open={openFilterRename}
                                    onClose={handleCloseFilterRename}
                                    className={classes.dialogOuterMedium}
                                    fullScreen={fullScreen}
                                    aria-labelledby="responsive-dialog-title"
                                  >
                                    <DialogTitle
                                      className={classes.dialogTitle}
                                      id="responsive-dialog-title"
                                    >
                                      <Typography variant="h2" noWrap component="span">
                                        {`Rename your search name as:`}
                                      </Typography>
                                      <IconButton
                                        aria-label="close"
                                        onClick={handleCloseFilterRename}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </DialogTitle>
                                    <DialogContent>
                                      {' '}
                                      <TextField
                                        autoFocus
                                        margin="dense"
                                        label="Edit Your Search Name"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={filterRename || ''}
                                        onChange={(e) => {
                                          if (e.target.value !== '') {
                                            setFilterRename(e.target.value);
                                          } else {
                                            setFilterRename('');
                                            setFilterRenameValid(true);
                                          }
                                        }}
                                        error={!isFilterRenameValid}
                                        helperText={
                                          !isFilterRenameValid && 'Required field missing'
                                        }
                                      />
                                    </DialogContent>
                                    <DialogActions>
                                      <Button
                                        onClick={async () => {
                                          if (filterRename.trim() === '') {
                                            setFilterRenameValid(false);
                                          } else {
                                            // Perform your save action here
                                            setAnchorEl(null);

                                            const filterObj = {
                                              id: filterSelectedUpdate[0]?.id,
                                              filterName: filterRename,
                                              userId: loggedInUserData?.id,
                                            };

                                            const result = await updateFilterName(filterObj);

                                            if (result) {
                                              handleMenuClose();
                                              result.duplicate && setShowSnackBarErr(true);
                                            }

                                            handleCloseFilterRename();
                                          }
                                        }}
                                        color="primary"
                                        variant="contained"
                                        autoFocus
                                      >
                                        Edit
                                      </Button>
                                      <Button
                                        onClick={handleCloseFilterRename}
                                        className={classes.secondaryBtnUI}
                                        variant="outlined"
                                        color="secondary"
                                      >
                                        Cancel
                                      </Button>
                                    </DialogActions>
                                  </Dialog>

                                  <Dialog
                                    open={openFilterValidation}
                                    onClose={handleCloseFilterValidation}
                                    className={classes.SmallDialog}
                                    fullScreen={fullScreen}
                                    aria-labelledby="responsive-dialog-title"
                                  >
                                    <DialogTitle
                                      className={classes.dialogTitle}
                                      id="responsive-dialog-title"
                                    >
                                      <Typography variant="h4" component="span">
                                        Please select at least one metric to save the search
                                      </Typography>
                                      <IconButton
                                        aria-label="close"
                                        onClick={handleCloseFilterValidation}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </DialogTitle>

                                    <DialogActions>
                                      <Button
                                        onClick={handleCloseFilterValidation}
                                        color="primary"
                                        variant="contained"
                                        autoFocus
                                      >
                                        OK
                                      </Button>
                                    </DialogActions>
                                  </Dialog>

                                  <Dialog
                                    open={openDeleteConfirmation}
                                    onClose={closeDeleteConfirmation}
                                    className={classes.SmallDialog}
                                    fullScreen={fullScreen}
                                    aria-labelledby="responsive-dialog-title"
                                  >
                                    <DialogTitle
                                      className={classes.dialogTitle}
                                      id="responsive-dialog-title"
                                    >
                                      <Typography variant="h4" component="span">
                                        Are you sure you want to delete{' '}
                                        {selectedSearchId
                                          ? 'your search'
                                          : 'all your saved searches'}
                                        ?
                                      </Typography>
                                      <IconButton
                                        aria-label="close"
                                        onClick={closeDeleteConfirmation}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </DialogTitle>

                                    <DialogActions>
                                      <Button
                                        onClick={() => {
                                          handleDeleteSavedSearches(
                                            { resetForm },
                                            selectedSearchId ? false : true,
                                          );
                                        }}
                                        color="primary"
                                        variant="contained"
                                        autoFocus
                                      >
                                        OK
                                      </Button>
                                    </DialogActions>
                                  </Dialog>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Box>

                          <Grid item xs={12} sm={12} md={12}>
                            <Box className={classes.innercontentWhite} style={{ height: '100%' }}>
                              <Grid container spacing={2}>
                                <Grid item xs={9}>
                                  <Grid container spacing={2} onClick={handleOutsideClick}>
                                    <If
                                      condition={
                                        savedSearches &&
                                        savedSearches.length > 0 &&
                                        savedSearches !== 'No Data'
                                      }
                                    >
                                      {' '}
                                      {savedSearches.map((entry, index) => (
                                        <Grid item key={entry.id}>
                                          <div className={classes.TableInnerFilter}>
                                            <Button
                                              variant="outlined"
                                              onClick={async (event) => {
                                                values = await handleSearchButtonClick(
                                                  event,
                                                  index,
                                                  entry?.id,
                                                  values,
                                                  'button',
                                                  { resetForm },
                                                );
                                              }}
                                              id={`button-${index}`} // Add id attribute with index value
                                            >
                                              {entry.filterName}
                                            </Button>
                                            <Button
                                              variant="outlined"
                                              onClick={(event) =>
                                                handleSearchButtonClick(
                                                  event,
                                                  index,
                                                  entry?.id,
                                                  values,
                                                  'arrow',
                                                  { resetForm },
                                                )
                                              }
                                              id={`buttonArrow-${index}`} // Add id attribute with index value
                                            >
                                              <KeyboardArrowDownIcon />
                                            </Button>
                                          </div>

                                          <Popover
                                            className={classes.MoreOptionsV2}
                                            id={`menu-${index}`}
                                            anchorEl={searchAnchorEl}
                                            open={Boolean(
                                              searchAnchorEl &&
                                                searchAnchorEl.id === `buttonArrow-${index}`,
                                            )}
                                            onClose={handleMenuClose}
                                            anchorOrigin={{
                                              vertical: 'bottom',
                                              horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                              vertical: 'top',
                                              horizontal: 'right',
                                            }}
                                          >
                                            <MenuItem
                                              onClick={() => {
                                                setFilterRenameValid(true);
                                                handleRenameButton(entry?.id);
                                              }}
                                            >
                                              Edit Name
                                            </MenuItem>

                                            <MenuItem
                                              onClick={() => {
                                                openDeleteConfirmationBox(entry?.id);
                                              }}
                                            >
                                              Delete Search
                                            </MenuItem>
                                          </Popover>
                                        </Grid>
                                      ))}
                                    </If>
                                  </Grid>
                                </Grid>
                                <Grid item xs={3} container justify="flex-end">
                                  <Box display="flex" alignItems="center">
                                    <Box display="flex" mr={3}>
                                      <FormControlLabel
                                        value="Edit Mode"
                                        control={
                                          <Switch
                                            disabled={
                                              selectedSearchIndex == null || !isApplyClicked
                                            }
                                            color="primary"
                                            size="small"
                                            title="Edit current search or start a new search tab "
                                            checked={filterEditMode}
                                            onChange={handleEditMode}
                                          />
                                        }
                                        label="Edit Mode "
                                        labelPlacement="start"
                                      />
                                    </Box>
                                    <Button
                                      type="submit"
                                      className={classes.button}
                                      disabled={
                                        !isApplyClicked &&
                                        (filteredFpData.length == 0 ||
                                          filteredFpDataClone.length == 0)
                                      }
                                      variant="outlined"
                                      onClick={async () => {
                                        if (filterEditMode) {
                                          setFilterNameValid(false);
                                          setFilterSubmitted(values);
                                          if (
                                            values['yearid'] &&
                                            values['fieldoptionid'] &&
                                            selectedSearchId
                                          ) {
                                            const filterObj = {
                                              id: selectedSearchId,
                                              metrics: values['fieldoptionid'] || [],
                                              country: values['countryid'] || [],
                                              cell: values['cellid'] || [],
                                              department: values['deptid'] || [],
                                              year: values['yearid'] || '',
                                              period: values['period'] || '',
                                            };
                                            const result = await updateSavedFilter(filterObj);
                                            if (result) {
                                              loadAllFilters();
                                              handleMenuClose();
                                            }
                                          } else {
                                            setOpenFilterValidation(true);
                                          }
                                        } else {
                                          if (values['yearid'] === undefined) {
                                            values['yearid'] =
                                              yearListForFilter.length > 0
                                                ? yearListForFilter[yearListForFilter.length - 1]
                                                    ?.id
                                                : '';
                                            setSelectedYear(values['yearid']);
                                          }

                                          if (values['yearid'] && values['fieldoptionid']) {
                                            setFilterNameValid(true);
                                            setOpenFilterName(true);
                                          } else {
                                            setOpenFilterValidation(true);
                                          }
                                        }

                                        handleClose();
                                      }}
                                    >
                                      {filterEditMode ? 'Save Changes' : 'Save Search'}
                                    </Button>
                                  </Box>
                                </Grid>
                              </Grid>
                              <Box>
                                <Grid container spacing={2}>
                                  <Grid item xs={10}>
                                    <Typography variant="h5">
                                      <span style={{ fontWeight: '800' }}>
                                        {!values?.yearid
                                          ? new Date().getFullYear()
                                          : yearListForFilter[Number(values?.yearid) - 1]
                                              ?.year}{' '}
                                        {(values?.period == 'fullYear' ? 'Year' : values?.period) ||
                                          ''}
                                      </span>{' '}
                                      {Object.entries(cellsByCountryIndicator).length > 0 && '- '}
                                      {((selectedCountryOption.length > 0 &&
                                        selectedCountryOption.length === countryList.length &&
                                        selectedFieldOption.length > 0 &&
                                        selectedCellOption.length == 0 &&
                                        selectedDepartmentOption.length == 0) ||
                                        (selectedCountryOption.length == 0 &&
                                          selectedFieldOption.length > 0 &&
                                          selectedCellOption.length == 0 &&
                                          selectedDepartmentOption.length > 0 &&
                                          selectedDepartmentOption.length ===
                                            deptListForFilter.length)) && <>[ All Vector ] </>}
                                      {!(
                                        selectedCountryOption.length > 0 &&
                                        selectedCountryOption.length === countryList.length
                                      ) &&
                                        Object.entries(cellsByCountryIndicator).length == 0 &&
                                        values?.countryid &&
                                        values?.countryid.length > 0 &&
                                        values?.countryid.map((country, index) => {
                                          const countryObj = isValidJSON(country)
                                            ? JSON.parse(country)
                                            : country;
                                          return (
                                            <span key={countryObj.id}>
                                              {countryObj.countryTitle}{' '}
                                              {index < values?.countryid.length - 1 && ', '}
                                            </span>
                                          );
                                        })}
                                      {Object.entries(cellsByCountryIndicator).map(
                                        ([country, cells], index, array) => (
                                          <React.Fragment key={country}>
                                            {country}{' '}
                                            {selectedCellOption.length <
                                              cellListForFilter.length && (
                                              <>
                                                {' '}
                                                <span style={{ fontWeight: '500' }}>
                                                  [ Cells {Array.from(cells).join(', ')} ]
                                                </span>
                                                {index !== array.length - 1 && ' '}
                                              </>
                                            )}
                                          </React.Fragment>
                                        ),
                                      )}
                                      {selectedCellOption.length > 0 &&
                                        selectedCellOption.length === cellListForFilter.length && (
                                          <>
                                            <span style={{ fontWeight: '500' }}>[All Cells]</span>{' '}
                                          </>
                                        )}
                                      {values?.deptid &&
                                        values?.deptid.length > 0 &&
                                        values?.deptid.map((dept, index) => {
                                          const deptObj = isValidJSON(dept)
                                            ? JSON.parse(dept)
                                            : dept;
                                          return (
                                            selectedDepartmentOption.length > 0 &&
                                            selectedDepartmentOption.length <
                                              deptListForFilter.length && (
                                              <>
                                                <span
                                                  style={{ fontWeight: '500' }}
                                                  key={deptObj.id}
                                                >
                                                  {index == 0 && '[ '}
                                                  {deptObj.department}
                                                  {index < values?.deptid.length - 1 && ', '}
                                                  {values?.deptid.length - 1 == index && ' ]'}
                                                </span>
                                              </>
                                            )
                                          );
                                        })}
                                      {selectedDepartmentOption.length > 0 &&
                                        selectedDepartmentOption.length ===
                                          deptListForFilter.length && (
                                          <>
                                            <span style={{ fontWeight: '500' }}>
                                              [All Departments]
                                            </span>{' '}
                                          </>
                                        )}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={2}>
                                    <ClickAwayListener onClickAway={handleClose}>
                                      <Box
                                        display="flex"
                                        justifyContent="end"
                                        className={classes.ThreeDotSearch}
                                      >
                                        <MoreVertIcon
                                          onClick={(event) => {
                                            setAnchorEl(event.currentTarget);
                                          }}
                                          className={classes.MoreOptionsIcon}
                                        />
                                        <Popover
                                          id="simple-menu"
                                          anchorEl={anchorEl}
                                          open={Boolean(anchorEl)}
                                          onClose={handleClose}
                                          className={classes.MoreOptionsV2}
                                          anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                          }}
                                          transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                          }}
                                        >
                                          <MenuItem
                                            onClick={() => {
                                              handleFocusModeClick();
                                              handleSubmenuClose();
                                              handleClose();
                                            }}
                                          >
                                            Focus Mode
                                          </MenuItem>
                                          <MenuItem
                                            disabled={
                                              filteredFpData.length == 0 ||
                                              hiddenColumns.length == 0
                                            }
                                            onClick={() => {
                                              handleToggleColumn();
                                              handleSubmenuClose();
                                              handleClose();
                                            }}
                                          >
                                            Unhide Columns
                                          </MenuItem>
                                          <MenuItem
                                            disabled={savedSearches == 'No Data'}
                                            onClick={openDeleteConfirmationBox}
                                          >
                                            Delete Saved Searches
                                          </MenuItem>
                                        </Popover>
                                      </Box>
                                    </ClickAwayListener>
                                  </Grid>
                                </Grid>
                              </Box>
                              <If condition={filteredFpData.length > 0}>
                                <Box className={classes.materialDTNewStyle}>
                                  {}
                                  {
                                    <div style={{ boxShadow: 'none' }}>
                                      <table
                                        className={classes.materialDT}
                                        cellPadding="0"
                                        cellSpacing="0"
                                      >
                                        <thead>{renderHeader()}</thead>
                                        <tbody>
                                          {displayedFpData.map((rowData, index) => (
                                            <tr key={index}>
                                              {filteredColumnList.map((column, colIndex) => {
                                                if (!hiddenColumns.includes(column?.field)) {
                                                  return column.field == 'ranking' ? (
                                                    <td key={colIndex}>
                                                      <span className={classes.RankingNumber}>
                                                        {rowData[column?.field].rankValue}
                                                      </span>
                                                    </td>
                                                  ) : column?.field == 'employee' ? (
                                                    <td
                                                      key={colIndex}
                                                      onClick={() => {
                                                        redirectPage(rowData);
                                                      }}
                                                    >
                                                      {rowData[column?.field]}
                                                    </td>
                                                  ) : (
                                                    <td key={colIndex}>{rowData[column?.field]}</td>
                                                  );
                                                }
                                              })}
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  }
                                </Box>
                              </If>
                              <If condition={filteredFpData.length === 0}>
                                <div style={containerStyle}>
                                  <If
                                    condition={
                                      isApplyClicked ||
                                      (!isApplyClicked &&
                                        selectedSearchId &&
                                        filteredFpData.length == 0)
                                    }
                                  >
                                    <Box py={2}>
                                      {' '}
                                      {!loaded ? (
                                        ''
                                      ) : (
                                        <Typography>
                                          {!values?.fieldoptionid
                                            ? 'Hmmm... Sorry, select metric and countries or departments to see the results '
                                            : values?.fieldoptionid &&
                                              values?.countryid &&
                                              values?.countryid.length == 0 &&
                                              (!values?.deptid || values?.deptid.length == 0)
                                            ? 'Hmmm... Sorry, select countries or departments to see the results for '
                                            : "Hmmm... Sorry, we couldn't find any matches for "}
                                          {values?.fieldoptionid &&
                                            values?.fieldoptionid
                                              .map(
                                                (field, index, array) =>
                                                  `${field}${
                                                    index !== array.length - 1 ? ', ' : ''
                                                  }`,
                                              )
                                              .join('\n')}
                                          {' in  '}
                                          {!values?.yearid
                                            ? new Date().getFullYear()
                                            : yearListForFilter[Number(values?.yearid) - 1]
                                                ?.year}{' '}
                                          {values?.period == 'fullYear' ? ' Year ' : values?.period}
                                          {values?.yearid &&
                                          values?.period &&
                                          values?.countryid &&
                                          values?.countryid.length > 0
                                            ? ', '
                                            : ''}
                                          {((selectedCountryOption.length > 0 &&
                                            selectedCountryOption.length === countryList.length &&
                                            selectedFieldOption.length > 0 &&
                                            selectedCellOption.length == 0 &&
                                            selectedDepartmentOption.length == 0) ||
                                            (selectedCountryOption.length == 0 &&
                                              selectedFieldOption.length > 0 &&
                                              selectedCellOption.length == 0 &&
                                              selectedDepartmentOption.length > 0 &&
                                              selectedDepartmentOption.length ===
                                                deptListForFilter.length)) && <>[ All Vector ] </>}
                                          {!(
                                            selectedCountryOption.length > 0 &&
                                            selectedCountryOption.length === countryList.length
                                          ) &&
                                            Object.entries(cellsByCountryIndicator).length == 0 &&
                                            values?.countryid &&
                                            values?.countryid.length > 0 &&
                                            values?.countryid.map((country, index) => {
                                              const countryObj = isValidJSON(country)
                                                ? JSON.parse(country)
                                                : country;
                                              return (
                                                <span key={countryObj.id}>
                                                  {countryObj.countryTitle}
                                                  {index < values?.countryid.length - 1 && ', '}
                                                </span>
                                              );
                                            })}
                                          {Object.entries(cellsByCountryIndicator).map(
                                            ([country, cells], index, array) => (
                                              <React.Fragment key={country}>
                                                {country}{' '}
                                                {selectedCellOption.length <
                                                  cellListForFilter.length && (
                                                  <>
                                                    {' '}
                                                    <span style={{ fontWeight: '500' }}>
                                                      [ Cells {Array.from(cells).join(', ')} ]
                                                    </span>
                                                    {index !== array.length - 1 && ' '}
                                                  </>
                                                )}
                                              </React.Fragment>
                                            ),
                                          )}
                                          {selectedCellOption.length > 0 &&
                                            selectedCellOption.length ===
                                              cellListForFilter.length && (
                                              <>
                                                <span style={{ fontWeight: '500' }}>
                                                  [All Cells]
                                                </span>{' '}
                                              </>
                                            )}
                                          {values?.deptid &&
                                            values?.deptid.length > 0 &&
                                            values?.deptid.map((dept, index) => {
                                              const deptObj = isValidJSON(dept)
                                                ? JSON.parse(dept)
                                                : dept;
                                              return (
                                                selectedDepartmentOption.length > 0 &&
                                                selectedDepartmentOption.length <
                                                  deptListForFilter.length && (
                                                  <>
                                                    <span
                                                      style={{ fontWeight: '500' }}
                                                      key={deptObj.id}
                                                    >
                                                      {index == 0 && '[ '}
                                                      {deptObj.department}
                                                      {index < values?.deptid.length - 1 && ', '}
                                                      {values?.deptid.length - 1 == index && ' ]'}
                                                    </span>
                                                  </>
                                                )
                                              );
                                            })}
                                          {selectedDepartmentOption.length > 0 &&
                                            selectedDepartmentOption.length ===
                                              deptListForFilter.length && (
                                              <>
                                                <span style={{ fontWeight: '500' }}>
                                                  [All Departments]
                                                </span>{' '}
                                              </>
                                            )}
                                          .{' '}
                                          {values?.fieldoptionid &&
                                            'Please try different search term.'}
                                        </Typography>
                                      )}
                                    </Box>
                                  </If>
                                  <If condition={values?.fieldoptionid && !isApplyClicked}>
                                    <Box mb={3}>
                                      <Typography variant="h2">
                                        Select a metric to view data
                                      </Typography>
                                    </Box>
                                    <img src={blankIMage} alt="Blank Image" style={imageStyle} />
                                    <Box mb={5}></Box>
                                  </If>
                                  <If condition={!values?.fieldoptionid}>
                                    <Box mb={3}>
                                      <Typography variant="h2">
                                        Select a metric to view data
                                      </Typography>
                                    </Box>
                                    <img src={blankIMage} alt="Blank Image" style={imageStyle} />
                                    <Box mb={5}></Box>
                                  </If>
                                </div>
                              </If>
                              <div className={classes.tableFooter}>
                                <div>
                                  <span style={{ marginRight: '10px' }}>Rows per page:</span>

                                  <FormControl>
                                    <Box>
                                      <Select
                                        labelId="demo-simple-select-filled-label"
                                        value={pageFpSize}
                                        onChange={handleFpPageSizeChange}
                                        disableUnderline
                                      >
                                        {pageFpSizeOptions.map((size) => (
                                          <MenuItem key={size} value={size}>
                                            {size}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </Box>
                                  </FormControl>
                                </div>
                                <div className={classes.footerArrowSection}>
                                  <span>{`${startFpIndex + 1}-${
                                    endFpIndex >= filteredFpData.length
                                      ? filteredFpData.length
                                      : endFpIndex
                                  } of ${filteredFpData.length}`}</span>
                                  <button
                                    disabled={currentFpPage === 1}
                                    onClick={() => handleFpPageChange(currentFpPage - 1)}
                                  >
                                    <ChevronLeftIcon />
                                  </button>
                                  <button
                                    disabled={endFpIndex >= filteredFpData.length}
                                    onClick={() => handleFpPageChange(currentFpPage + 1)}
                                  >
                                    <ChevronRightIcon />
                                  </button>
                                </div>
                              </div>
                            </Box>
                          </Grid>
                        </>
                      );
                    }}
                  </Formik>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Snackbar open={showSnackBarErr} autoHideDuration={6000} onClose={handleSnackBarClose}>
              <Alert elevation={6} variant="filled" onClose={handleSnackBarClose} severity="error">
                The provided search name already exists.
              </Alert>
            </Snackbar>
          </Grid>

          <Grid item xs={12}></Grid>
        </Grid>
      </If>
      <If condition={!isFinAnalysisVisible}>
        <Box py={2}>
          <Box className={classes.innercontentWhite}>
            <Typography variant="body2">This section is not permitted</Typography>
          </Box>
        </Box>
      </If>
    </>
  );
};
export default EmployeePerformance;
